// Hosted content URL.
const hostedContentUrl = 'https://rs.craftingly.co.uk'

jQuery(document).ready(function () {
  // FAQ MODALS
  $('.faq-modal').click(function () {
    window.open($(this).attr('href'), 'title', 'width=600, height=600')
    return false
  })

  // PRODUCT PAGE TABS
  jQuery('.section-banner').click(function () {
    const sectionToToggle = jQuery('.section-content[data-section="' + jQuery(this).attr('data-section') + '"]')

    if (sectionToToggle.hasClass('section-open')) {
      sectionToToggle.removeClass('section-open').slideUp(150)
      jQuery(this).find('.toggle-icon').text('+')
    } else {
      sectionToToggle.addClass('section-open').slideDown(150)
      jQuery(this).find('.toggle-icon').text('—')
    }
  })

  // 100% HERO HEIGHT
  function heroFullHeight() {
    const innerHeight = jQuery(window).innerHeight()
    const innerWidth = jQuery(window).innerWidth()

    // If the window inner width is below 1400px.
    if (innerWidth < 1400) {
      jQuery('#homepage-hero-container').css('height', innerHeight - 85)
    }
  }
  // On Resize
  jQuery(window).on('resize', function () {
    heroFullHeight()
  })

  // Discipline Hero
  jQuery('.discipline-hero .video-button').click(function () {
    jQuery('#image-popup-outer').addClass('visible').css('z-index', '9999')

    jQuery(document).click(function (e) {
      if ((e.target.getAttribute('class') !== 'video-button' && !jQuery('#image-popup-content').has(e.target).length && e.target.getAttribute('id') !== 'image-popup-content' && jQuery('#image-popup-outer').hasClass('visible')) || e.target.getAttribute('id') === 'image-popup-close') {
        jQuery('#image-popup-outer').removeClass('visible')
        setTimeout(function () {
          jQuery('#image-popup-outer').css('z-index', '-9999')
        }, 100)
      }
    })
  })

  // SEARCH FUNCTIONALITY
  jQuery('.search-icon').click(function () {
    if (jQuery('.search-icon').hasClass('open')) {
      jQuery('.search-icon').removeClass('open')
      jQuery('.header-search').removeClass('open')

      setTimeout(function () {
        jQuery('.search-icon').removeClass('red')
      }, 100)
    } else {
      jQuery('.search-icon').addClass('open')
      jQuery('.header-search').addClass('open')

      setTimeout(function () {
        jQuery('.search-icon').addClass('open')
        jQuery('.header-search input').focus()
      }, 100)
    }
  })

  jQuery('*').on('click', function (event) {
    const container = jQuery('.header-search, .search-icon')
    if (!container.is(event.target) && container.has(event.target).length === 0) {
      if (jQuery('.search-icon').hasClass('open')) {
        jQuery('.search-icon').removeClass('open')
        jQuery('.header-search').removeClass('open')

        setTimeout(function () {
          jQuery('.search-icon').removeClass('open')
        }, 100)
      }
    }
  })
})

jQuery(window).on('load', function () {
  jQuery('#tooltip_popup').popup({ transition: 'all 0.3s', opacity: 0.3 })

  const tooltipsAvailable = []
  jQuery('.tooltip-popup-content').each(function () {
    tooltipsAvailable.push(jQuery(this).attr('data-popup'))
  })

  jQuery('#product .selector-wrapper label').each(function () {
    const optionLabelText = jQuery(this).find('.label-inner').text().trim().replace('*', '')

    if (tooltipsAvailable.includes(optionLabelText)) {
      jQuery(this).append('<span class="tooltip_popup_open option-tooltip no-select" data-popup="' + optionLabelText + '">?</span>')
    }
  })

  jQuery('#product fieldset legend').each(function () {
    const optionLabelText = jQuery(this).find('.label-inner').text().trim().replace('*', '')

    if (tooltipsAvailable.includes(optionLabelText)) {
      jQuery(this).append('<span class="tooltip_popup_open option-tooltip no-select" data-popup="' + optionLabelText + '">?</span>')
    }
  })

  const customOptionLabels = document.querySelectorAll('.custom-product-options .custom-product-option-container label')
  customOptionLabels && customOptionLabels.forEach(customOptionLabel => {
    const label = customOptionLabel.querySelector('.label-inner')
    if (label) {
      const labelText = label.textContent
      tooltipsAvailable.includes(customOptionLabel.querySelector('.label-inner').textContent) && customOptionLabel.insertAdjacentHTML('beforeend', '<span class="tooltip_popup_open option-tooltip no-select" data-popup="' + labelText + '">?</span>')
    }
  })

  jQuery('#product .tooltip_popup_open').click(function () {
    const clickedTooltip = jQuery(this).attr('data-popup')

    jQuery('#tooltip_popup .tooltip-popup-content').each(function () {
      jQuery(this).css('display', 'block')
      if (jQuery(this).attr('data-popup') !== clickedTooltip) {
        jQuery(this).css('display', 'none')
      }
    })
  })
})

/********************************/
window.theme = window.theme || {}

theme.Sections = function Sections() {
  this.constructors = {}
  this.instances = []

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this))
}

theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    const $container = $(container)
    const id = $container.attr('data-section-id')
    const type = $container.attr('data-section-type')

    constructor = constructor || this.constructors[type]

    if (_.isUndefined(constructor)) {
      return
    }

    const instance = _.assignIn(new constructor(container), {
      id: id,
      type: type,
      container: container
    })

    this.instances.push(instance)
  },

  _onSectionLoad: function (evt) {
    const container = $('[data-section-id]', evt.target)[0]
    if (container) {
      this._createInstance(container)
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = _.filter(this.instances, function (instance) {
      const isEventInstance = instance.id === evt.detail.sectionId

      if (isEventInstance) {
        if (_.isFunction(instance.onUnload)) {
          instance.onUnload(evt)
        }
      }

      return !isEventInstance
    })
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onSelect)) {
      instance.onSelect(evt)
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onDeselect)) {
      instance.onDeselect(evt)
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockSelect)) {
      instance.onBlockSelect(evt)
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    const instance = _.find(this.instances, function (instance) {
      return instance.id === evt.detail.sectionId
    })

    if (!_.isUndefined(instance) && _.isFunction(instance.onBlockDeselect)) {
      instance.onBlockDeselect(evt)
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor

    $('[data-section-type=' + type + ']').each(
      function (index, container) {
        this._createInstance(container, constructor)
      }.bind(this)
    )
  }
})

window.slate = window.slate || {}

/**
 * Slate utilities
 * -----------------------------------------------------------------------------
 * A collection of useful utilities to help build your theme
 *
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Get the query params in a Url
   * Ex
   * https://mysite.com/search?q=noodles&b
   * getParameterByName('q') = "noodles"
   * getParameterByName('b') = "" (empty value)
   * getParameterByName('test') = null (absent)
   */
  getParameterByName: function (name, url) {
    if (!url) url = window.location.href
    name = name.replace(/[[\]]/g, '\\$&')
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    const results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  },

  keyboardKeys: {
    TAB: 9,
    ENTER: 13,
    ESCAPE: 27,
    LEFTARROW: 37,
    RIGHTARROW: 39
  }
}

window.slate = window.slate || {}

/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function (options) {
    options.$tables.wrap(
      '<div class="' + options.tableWrapperClass + '"></div>'
    )
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function (options) {
    options.$iframes.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + options.iframeWrapperClass + '"></div>')

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src
    })
  }
}

window.slate = window.slate || {}

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function ($element) {
    const focusClass = 'js-focus-hidden'

    $element
      .first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback)

    function callback() {
      $element
        .first()
        .removeClass(focusClass)
        .removeAttr('tabindex')
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function () {
    const hash = window.location.hash

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash))
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function () {
    $('a[href*=#]').on(
      'click',
      function (evt) {
        this.pageLinkFocus($(evt.currentTarget.hash))
      }.bind(this)
    )
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function (options) {
    const eventsName = {
      focusin: options.namespace ? 'focusin.' + options.namespace : 'focusin',
      focusout: options.namespace
        ? 'focusout.' + options.namespace
        : 'focusout',
      keydown: options.namespace
        ? 'keydown.' + options.namespace
        : 'keydown.handleFocus'
    }

    /**
     * Get every possible visible focusable element
     */
    const $focusableElements = options.$container.find(
      $(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])'
      ).filter(':visible')
    )
    const firstFocusable = $focusableElements[0]
    const lastFocusable = $focusableElements[$focusableElements.length - 1]

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container
    }

    function _manageFocus(evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.TAB) return

      /**
       * On the last focusable element and tab forward,
       * focus the first element.
       */
      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault()
        firstFocusable.focus()
      }
      /**
       * On the first focusable element and tab backward,
       * focus the last element.
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault()
        lastFocusable.focus()
      }
    }

    options.$container.attr('tabindex', '-1')
    options.$elementToFocus.focus()

    $(document).off('focusin')

    $(document).on(eventsName.focusout, function () {
      $(document).off(eventsName.keydown)
    })

    $(document).on(eventsName.focusin, function (evt) {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return

      $(document).on(eventsName.keydown, function (evt) {
        _manageFocus(evt)
      })
    })
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function (options) {
    const eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin'

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex')
    }

    $(document).off(eventName)
  },

  /**
   * Add aria-describedby attribute to external and new window links
   *
   * @param {object} options - Options to be used
   * @param {object} options.messages - Custom messages to be used
   * @param {jQuery} options.$links - Specific links to be targeted
   */
  accessibleLinks: function (options) {
    const body = document.querySelector('body')

    const idSelectors = {
      newWindow: 'a11y-new-window-message',
      external: 'a11y-external-message',
      newWindowExternal: 'a11y-new-window-external-message'
    }

    if (options.$links === undefined || !options.$links.jquery) {
      options.$links = $('a[href]:not([aria-describedby])')
    }

    function generateHTML(customMessages) {
      if (typeof customMessages !== 'object') {
        customMessages = {}
      }

      const messages = $.extend(
        {
          newWindow: 'Opens in a new window.',
          external: 'Opens external website.',
          newWindowExternal: 'Opens external website in a new window.'
        },
        customMessages
      )

      const container = document.createElement('ul')
      let htmlMessages = ''

      for (const message in messages) {
        htmlMessages +=
          '<li id=' + idSelectors[message] + '>' + messages[message] + '</li>'
      }

      container.setAttribute('hidden', true)
      container.innerHTML = htmlMessages

      body.appendChild(container)
    }

    function _externalSite($link) {
      const hostname = window.location.hostname

      return $link[0].hostname !== hostname
    }

    $.each(options.$links, function () {
      const $link = $(this)
      const target = $link.attr('target')
      const rel = $link.attr('rel')
      const isExternal = _externalSite($link)
      const isTargetBlank = target === '_blank'

      if (isExternal) {
        $link.attr('aria-describedby', idSelectors.external)
      }
      if (isTargetBlank) {
        if (rel === undefined || rel.indexOf('noopener') === -1) {
          $link.attr('rel', function (i, val) {
            const relValue = val === undefined ? '' : val + ' '
            return relValue + 'noopener'
          })
        }
        $link.attr('aria-describedby', idSelectors.newWindow)
      }
      if (isExternal && isTargetBlank) {
        $link.attr('aria-describedby', idSelectors.newWindowExternal)
      }
    })

    generateHTML(options.messages)
  }
}

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images]
    }

    for (let i = 0; i < images.length; i++) {
      const image = images[i]
      this.loadImage(this.getSizedImageUrl(image, size))
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path
  }

  /**
   * Swaps the src of an image for another OR returns the imageURL to the callback function
   * @param image
   * @param element
   * @param callback
   */
  function switchImage(image, element, callback) {
    const size = this.imageSize(element.src)
    const imageUrl = this.getSizedImageUrl(image.src, size)

    if (callback) {
      callback(imageUrl, image, element) // eslint-disable-line callback-return
    } else {
      element.src = imageUrl
    }
  }

  /**
   * +++ Useful
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    const match = src.match(
      /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\\.@]/
    )

    if (match !== null) {
      if (match[2] !== undefined) {
        return match[1] + match[2]
      } else {
        return match[1]
      }
    } else {
      return null
    }
  }

  /**
   * +++ Useful
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src
    }

    if (size === 'master') {
      return this.removeProtocol(src)
    }

    const match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    )

    if (match !== null) {
      const prefix = src.split(match[0])
      const suffix = match[0]

      return this.removeProtocol(prefix[0] + '_' + size + suffix)
    }

    return null
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '')
  }

  return {
    preload: preload,
    loadImage: loadImage,
    switchImage: switchImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  }
})()

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function () {
  const moneyFormat = '${{amount}}' // eslint-disable-line camelcase

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '')
    }
    let value = ''
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    const formatString = format || moneyFormat

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ','
      decimal = decimal || '.'

      if (isNaN(number) || number === null) {
        return 0
      }

      number = (number / 100.0).toFixed(precision)

      const parts = number.split('.')
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      )
      const centsAmount = parts[1] ? decimal + parts[1] : ''

      return dollarsAmount + centsAmount
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ')
        break
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'")
        break
    }

    return formatString.replace(placeholderRegex, value)
  }

  return {
    formatMoney: formatMoney
  }
})()

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist.  Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container
    this.product = options.product
    this.singleOptionSelector = options.singleOptionSelector
    this.originalSelectorId = options.originalSelectorId
    this.enableHistoryState = options.enableHistoryState
    this.currentVariant = this._getVariantFromOptions()

    $(this.singleOptionSelector, this.$container).on(
      'change',
      this._onSelectChange.bind(this)
    )
  }

  Variants.prototype = _.assignIn({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function () {
      let currentOptions = _.map(
        $(this.singleOptionSelector, this.$container),
        function (element) {
          const $element = $(element)
          const type = $element.attr('type')
          const currentOption = {}

          if (type === 'radio' || type === 'checkbox') {
            if ($element[0].checked) {
              currentOption.value = $element.val()
              currentOption.index = $element.data('index')

              return currentOption
            } else {
              return false
            }
          } else {
            currentOption.value = $element.val()
            currentOption.index = $element.data('index')

            return currentOption
          }
        }
      )

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = _.compact(currentOptions)

      return currentOptions
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function () {
      const selectedValues = this._getCurrentOptions()
      const variants = this.product.variants

      const found = _.find(variants, function (variant) {
        return selectedValues.every(function (values) {
          return _.isEqual(variant[values.index], values.value)
        })
      })

      return found
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function () {
      const variant = this._getVariantFromOptions()

      this.$container.trigger({
        type: 'variantChange',
        product: this.product,
        variant: variant
      })

      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant, product: this.product }, bubbles: true }))

      if (!variant) {
        return
      }

      this._updateMasterSelect(variant)
      // this._updateImages(variant);
      this._customOptionsShow(variant)
      this._updatePrice(variant)
      this._updateSKU(variant)

      this.currentVariant = variant

      if (this.enableHistoryState) {
        this._updateHistoryState(variant)
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function (variant) {
      const variantImage = variant.featured_image || {}
      const currentVariantImage = this.currentVariant.featured_image || {}

      if (
        !variant.featured_image ||
        variantImage.src === currentVariantImage.src
      ) {
        //         return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      })
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function (variant) {
      if (
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        return
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      })
    },

    /**
     * Trigger event when variant sku changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantSKUChange
     */
    _updateSKU: function (variant) {
      if (variant.sku === this.currentVariant.sku) {
        return
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      })
    },

    _customOptionsShow: function (variant) {
      const customOptionsContainers = document.querySelectorAll('.custom-product-option-container[data-option]')
      customOptionsContainers.forEach(container => {
        if (!container.hasAttribute('data-value')) return
        if (variant.options.includes(container.getAttribute('data-value'))) {
          container.classList.remove('hide')
          container.querySelector('.custom-product-option-fieldset').removeAttribute('disabled')
          return
        }
        container.classList.add('hide')
        container.querySelector('.custom-product-option-fieldset').setAttribute('disabled', '')
      })
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function (variant) {
      if (!history.replaceState || !variant) {
        return
      }

      const newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?variant=' +
        variant.id
      window.history.replaceState({ path: newurl }, '', newurl)
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function (variant) {
      $(this.originalSelectorId, this.$container).val(variant.id)
    }
  })

  return Variants
})()

/* ================ GLOBAL ================ */
/* ============================================================================
  Drawer modules
============================================================================== */
theme.Drawers = (function () {
  function Drawer(id, position, options) {
    const defaults = {
      close: '.js-drawer-close',
      open: '.js-drawer-open-' + position,
      openClass: 'js-drawer-open',
      dirOpenClass: 'js-drawer-open-' + position
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $page: $('#PageContainer')
    }

    this.config = $.extend(defaults, options)
    this.position = position

    this.$drawer = $('#' + id)

    if (!this.$drawer.length) {
      return false
    }

    this.drawerIsOpen = false
    this.init()
  }

  Drawer.prototype.init = function () {
    $(this.config.open).on('click', $.proxy(this.open, this))
    this.$drawer.on('click', this.config.close, $.proxy(this.close, this))
  }

  Drawer.prototype.open = function (evt) {
    // Keep track if drawer was opened from a click, or called by another function
    let externalCall = false

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault()
    } else {
      externalCall = true
    }

    // Without this, the drawer opens, the click event bubbles up to nodes.$page
    // which closes the drawer.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation()
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget)
    }

    if (this.drawerIsOpen && !externalCall) {
      return this.close()
    }

    // Add is-transitioning class to moved elements on open so drawer can have
    // transition for close animation
    this.$drawer.prepareTransition()

    this.nodes.$parent.addClass(
      this.config.openClass + ' ' + this.config.dirOpenClass
    )
    this.drawerIsOpen = true

    // Set focus on drawer
    slate.a11y.trapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    })

    // Run function when draw opens if set
    if (
      this.config.onDrawerOpen &&
      typeof this.config.onDrawerOpen === 'function'
    ) {
      if (!externalCall) {
        this.config.onDrawerOpen()
      }
    }

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true')
    }

    this.bindEvents()

    return this
  }

  Drawer.prototype.close = function () {
    if (!this.drawerIsOpen) {
      // don't close a closed drawer
      return
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur')

    // Ensure closing transition is applied to moved elements, like the nav
    this.$drawer.prepareTransition()

    this.nodes.$parent.removeClass(
      this.config.dirOpenClass + ' ' + this.config.openClass
    )

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false')
    }

    this.drawerIsOpen = false

    // Remove focus on drawer
    slate.a11y.removeTrapFocus({
      $container: this.$drawer,
      namespace: 'drawer_focus'
    })

    this.unbindEvents()

    // Run function when draw closes if set
    if (
      this.config.onDrawerClose &&
      typeof this.config.onDrawerClose === 'function'
    ) {
      this.config.onDrawerClose()
    }
  }

  Drawer.prototype.bindEvents = function () {
    this.nodes.$parent.on(
      'keyup.drawer',
      $.proxy(function (evt) {
        // close on 'esc' keypress
        if (evt.keyCode === 27) {
          this.close()
          return false
        } else {
          return true
        }
      }, this)
    )

    // Lock scrolling on mobile
    this.nodes.$page.on('touchmove.drawer', function () {
      return false
    })

    this.nodes.$page.on(
      'click.drawer',
      $.proxy(function () {
        this.close()
        return false
      }, this)
    )
  }

  Drawer.prototype.unbindEvents = function () {
    this.nodes.$page.off('.drawer')
    this.nodes.$parent.off('.drawer')
  }

  return Drawer
})()

/* ================ MODULES ================ */
window.theme = window.theme || {}

theme.Header = (function () {
  const selectors = {
    body: 'body',
    multicurrencySelector: '[data-currency-selector]',
    navigation: '#AccessibleNav',
    siteNavHasDropdown: '[data-has-dropdowns]',
    siteNavChildLinks: '.site-nav__child-link',
    siteNavActiveDropdown: '.site-nav--active-dropdown',
    siteNavHasCenteredDropdown: '.site-nav--has-centered-dropdown',
    siteNavCenteredDropdown: '.site-nav__dropdown--centered',
    siteNavLinkMain: '.site-nav__link--main',
    siteNavChildLink: '.site-nav__link--last',
    siteNavDropdown: '.site-nav__dropdown',
    siteHeader: '.site-header'
  }

  const config = {
    activeClass: 'site-nav--active-dropdown',
    childLinkClass: 'site-nav__child-link',
    rightDropdownClass: 'site-nav__dropdown--right',
    leftDropdownClass: 'site-nav__dropdown--left'
  }

  let cache = {}

  function init() {
    cacheSelectors()
    styleDropdowns($(selectors.siteNavHasDropdown))
    positionFullWidthDropdowns()

    cache.$parents.on('click.siteNav', function () {
      const $el = $(this)
      $el.hasClass(config.activeClass) ? hideDropdown($el) : showDropdown($el)
    })

    // check when we're leaving a dropdown and close the active dropdown
    $(selectors.siteNavChildLink).on('focusout.siteNav', function () {
      setTimeout(function () {
        if (
          $(document.activeElement).hasClass(config.childLinkClass) ||
          !cache.$activeDropdown.length
        ) {
          return
        }

        hideDropdown(cache.$activeDropdown)
      })
    })

    // close dropdowns when on top level nav
    cache.$topLevel.on('focus.siteNav', function () {
      if (cache.$activeDropdown.length) {
        hideDropdown(cache.$activeDropdown)
      }
    })

    cache.$subMenuLinks.on('click.siteNav', function (evt) {
      // Prevent click on body from firing instead of link
      evt.stopImmediatePropagation()
    })

    $(selectors.multicurrencySelector).on('change', function () {
      $(this)
        .parents('form')
        .submit()
    })

    $(window).resize(
      $.debounce(50, function () {
        styleDropdowns($(selectors.siteNavHasDropdown))
        positionFullWidthDropdowns()
      })
    )
  }

  function cacheSelectors() {
    cache = {
      $nav: $(selectors.navigation),
      $topLevel: $(selectors.siteNavLinkMain),
      $parents: $(selectors.navigation).find(selectors.siteNavHasDropdown),
      $subMenuLinks: $(selectors.siteNavChildLinks),
      $activeDropdown: $(selectors.siteNavActiveDropdown),
      $siteHeader: $(selectors.siteHeader)
    }
  }

  function showDropdown($el) {
    $el.addClass(config.activeClass)

    // close open dropdowns
    if (cache.$activeDropdown.length) {
      hideDropdown(cache.$activeDropdown)
    }

    cache.$activeDropdown = $el

    // set expanded on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'true')

    setTimeout(function () {
      $(window).on('keyup.siteNav', function (evt) {
        if (evt.keyCode === 27) {
          hideDropdown($el)
        }
      })

      $(selectors.body).on('click.siteNav', function () {
        hideDropdown($el)
      })
    }, 250)
  }

  function hideDropdown($el) {
    // remove aria on open dropdown
    $el.find(selectors.siteNavLinkMain).attr('aria-expanded', 'false')
    $el.removeClass(config.activeClass)

    // reset active dropdown
    cache.$activeDropdown = $(selectors.siteNavActiveDropdown)

    $(selectors.body).off('click.siteNav')
    $(window).off('keyup.siteNav')
  }

  function styleDropdowns($dropdownListItems) {
    $dropdownListItems.each(function () {
      const $dropdownLi = $(this).find(selectors.siteNavDropdown)
      if (!$dropdownLi.length) {
        return
      }
      const isRightOfLogo =
        Math.ceil($(this).offset().left) >
        Math.floor(cache.$siteHeader.outerWidth()) / 2
      if (isRightOfLogo) {
        $dropdownLi
          .removeClass(config.leftDropdownClass)
          .addClass(config.rightDropdownClass)
      } else {
        $dropdownLi
          .removeClass(config.rightDropdownClass)
          .addClass(config.leftDropdownClass)
      }
    })
  }

  function positionFullWidthDropdowns() {
    const $listWithCenteredDropdown = $(selectors.siteNavHasCenteredDropdown)

    $listWithCenteredDropdown.each(function () {
      const $hasCenteredDropdown = $(this)
      const $fullWidthDropdown = $hasCenteredDropdown.find(
        selectors.siteNavCenteredDropdown
      )

      const fullWidthDropdownOffset = $hasCenteredDropdown.position().top + 41
      $fullWidthDropdown.css('top', fullWidthDropdownOffset)
    })
  }

  function unload() {
    $(window).off('.siteNav')
    cache.$parents.off('.siteNav')
    cache.$subMenuLinks.off('.siteNav')
    cache.$topLevel.off('.siteNav')
    $(selectors.siteNavChildLink).off('.siteNav')
    $(selectors.body).off('.siteNav')
  }

  return {
    init: init,
    unload: unload
  }
})()

window.theme = window.theme || {}

theme.MobileNav = (function () {
  const classes = {
    mobileNavOpenIcon: 'mobile-nav--open',
    mobileNavCloseIcon: 'mobile-nav--close',
    navLinkWrapper: 'mobile-nav__item',
    navLink: 'mobile-nav__link',
    subNavLink: 'mobile-nav__sublist-link',
    return: 'mobile-nav__return-btn',
    subNavActive: 'is-active',
    subNavClosing: 'is-closing',
    navOpen: 'js-menu--is-open',
    subNavShowing: 'sub-nav--is-open',
    thirdNavShowing: 'third-nav--is-open',
    subNavToggleBtn: 'js-toggle-submenu'
  }
  let cache = {}
  let isTransitioning
  let $activeSubNav
  let $activeTrigger
  let menuLevel = 1
  // Breakpoints from src/stylesheets/global/variables.scss.liquid
  const mediaQuerySmall = 'screen and (max-width: 749px)'

  function init() {
    cacheSelectors()

    cache.$mobileNavToggle.on('click', toggleMobileNav)
    cache.$subNavToggleBtn.on('click.subNav', toggleSubNav)

    // Close mobile nav when unmatching mobile breakpoint
    enquire.register(mediaQuerySmall, {
      unmatch: function () {
        if (cache.$mobileNavContainer.hasClass(classes.navOpen)) {
          closeMobileNav()
        }
      }
    })
  }

  function toggleMobileNav() {
    if (cache.$mobileNavToggle.hasClass(classes.mobileNavCloseIcon)) {
      closeMobileNav()
    } else {
      openMobileNav()
    }
  }

  function cacheSelectors() {
    cache = {
      $pageContainer: $('#PageContainer'),
      $siteHeader: $('.site-header'),
      $mobileNavToggle: $('.js-mobile-nav-toggle'),
      $mobileNavContainer: $('.mobile-nav-wrapper'),
      $mobileNav: $('#MobileNav'),
      $sectionHeader: $('#shopify-section-header'),
      $subNavToggleBtn: $('.' + classes.subNavToggleBtn)
    }
  }

  function openMobileNav() {
    const translateHeaderHeight = cache.$siteHeader.outerHeight()

    cache.$mobileNavContainer.prepareTransition().addClass(classes.navOpen)

    cache.$mobileNavContainer.css({
      transform: 'translateY(' + translateHeaderHeight + 'px)'
    })

    cache.$pageContainer.css({
      transform:
        'translate3d(0, ' + cache.$mobileNavContainer[0].scrollHeight + 'px, 0)'
    })

    slate.a11y.trapFocus({
      $container: cache.$sectionHeader,
      $elementToFocus: cache.$mobileNavToggle,
      namespace: 'navFocus'
    })

    cache.$mobileNavToggle
      .addClass(classes.mobileNavCloseIcon)
      .removeClass(classes.mobileNavOpenIcon)
      .attr('aria-expanded', true)

    // close on escape
    $(window).on('keyup.mobileNav', function (evt) {
      if (evt.which === 27) {
        closeMobileNav()
      }
    })
  }

  function closeMobileNav() {
    cache.$mobileNavContainer.prepareTransition().removeClass(classes.navOpen)

    cache.$mobileNavContainer.css({
      transform: 'translateY(-100%)'
    })

    cache.$pageContainer.removeAttr('style')

    slate.a11y.trapFocus({
      $container: $('html'),
      $elementToFocus: $('body')
    })

    cache.$mobileNavContainer.one(
      'TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle',
      function () {
        slate.a11y.removeTrapFocus({
          $container: cache.$mobileNav,
          namespace: 'navFocus'
        })
      }
    )

    cache.$mobileNavToggle
      .addClass(classes.mobileNavOpenIcon)
      .removeClass(classes.mobileNavCloseIcon)
      .attr('aria-expanded', false)
      .focus()

    $(window).off('keyup.mobileNav')

    scrollTo(0, 0)
  }

  function toggleSubNav(evt) {
    if (isTransitioning) {
      return
    }

    const $toggleBtn = $(evt.currentTarget)
    const isReturn = $toggleBtn.hasClass(classes.return)
    isTransitioning = true

    if (isReturn) {
      // Close all subnavs by removing active class on buttons
      $(
        '.' + classes.subNavToggleBtn + '[data-level="' + (menuLevel - 1) + '"]'
      ).removeClass(classes.subNavActive)

      if ($activeTrigger && $activeTrigger.length) {
        $activeTrigger.removeClass(classes.subNavActive)
      }
    } else {
      $toggleBtn.addClass(classes.subNavActive)
    }

    $activeTrigger = $toggleBtn

    goToSubnav($toggleBtn.data('target'))
  }

  function goToSubnav(target) {
    /* eslint-disable shopify/jquery-dollar-sign-reference */

    const $targetMenu = target
      ? $('.mobile-nav__dropdown[data-parent="' + target + '"]')
      : cache.$mobileNav

    menuLevel = $targetMenu.data('level') ? $targetMenu.data('level') : 1

    if ($activeSubNav && $activeSubNav.length) {
      $activeSubNav.prepareTransition().addClass(classes.subNavClosing)
    }

    $activeSubNav = $targetMenu

    /* eslint-enable shopify/jquery-dollar-sign-reference */

    const translateMenuHeight = $targetMenu.outerHeight()

    const openNavClass =
      menuLevel > 2 ? classes.thirdNavShowing : classes.subNavShowing

    cache.$mobileNavContainer
      .css('height', translateMenuHeight)
      .removeClass(classes.thirdNavShowing)
      .addClass(openNavClass)

    if (!target) {
      // Show top level nav
      cache.$mobileNavContainer
        .removeClass(classes.thirdNavShowing)
        .removeClass(classes.subNavShowing)
    }

    /* if going back to first subnav, focus is on whole header */
    const $container = menuLevel === 1 ? cache.$sectionHeader : $targetMenu

    const $menuTitle = $targetMenu.find('[data-menu-title=' + menuLevel + ']')
    const $elementToFocus = $menuTitle || $targetMenu

    // Focusing an item in the subnav early forces element into view and breaks the animation.
    cache.$mobileNavContainer.one(
      'TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle',
      function () {
        slate.a11y.trapFocus({
          $container: $container,
          $elementToFocus: $elementToFocus,
          namespace: 'subNavFocus'
        })

        cache.$mobileNavContainer.off('.subnavToggle')
        isTransitioning = false
      }
    )

    // Match height of subnav
    cache.$pageContainer.css({
      transform: 'translateY(' + translateMenuHeight + 'px)'
    })

    $activeSubNav.removeClass(classes.subNavClosing)
  }

  return {
    init: init,
    closeMobileNav: closeMobileNav
  }
})(jQuery)

window.theme = window.theme || {}

theme.Search = (function () {
  const selectors = {
    search: '.search',
    searchSubmit: '.search__submit',
    searchInput: '.search__input',

    siteHeader: '.site-header',
    siteHeaderSearchToggle: '.site-header__search-toggle',
    siteHeaderSearch: '.site-header__search',

    searchDrawer: '.search-bar',
    searchDrawerInput: '.search-bar__input',

    searchHeader: '.search-header',
    searchHeaderInput: '.search-header__input',
    searchHeaderSubmit: '.search-header__submit',

    searchResultSubmit: '#SearchResultSubmit',
    searchResultInput: '#SearchInput',
    searchResultMessage: '[data-search-error-message]',

    mobileNavWrapper: '.mobile-nav-wrapper'
  }

  const classes = {
    focus: 'search--focus',
    hidden: 'hide',
    mobileNavIsOpen: 'js-menu--is-open'
  }

  function init() {
    if (!$(selectors.siteHeader).length) {
      return
    }

    this.$searchResultInput = $(selectors.searchResultInput)
    this.$searchErrorMessage = $(selectors.searchResultMessage)

    initDrawer()

    const isSearchPage =
      slate.utils.getParameterByName('q') !== null &&
      window.location.pathname === '/search'

    if (isSearchPage) {
      validateSearchResultForm.call(this)
    }

    $(selectors.searchResultSubmit).on(
      'click',
      validateSearchResultForm.bind(this)
    )

    $(selectors.searchHeaderInput)
      .add(selectors.searchHeaderSubmit)
      .on('focus blur', function () {
        $(selectors.searchHeader).toggleClass(classes.focus)
      })

    $(selectors.siteHeaderSearchToggle).on('click', function () {
      const searchHeight = $(selectors.siteHeader).outerHeight()
      const searchOffset = $(selectors.siteHeader).offset().top - searchHeight

      $(selectors.searchDrawer).css({
        height: searchHeight + 'px',
        top: searchOffset + 'px'
      })
    })
  }

  function initDrawer() {
    // Add required classes to HTML
    $('#PageContainer').addClass('drawer-page-content')
    $('.js-drawer-open-top')
      .attr('aria-controls', 'SearchDrawer')
      .attr('aria-expanded', 'false')
      .attr('aria-haspopup', 'dialog')

    theme.SearchDrawer = new theme.Drawers('SearchDrawer', 'top', {
      onDrawerOpen: searchDrawerFocus,
      onDrawerClose: searchDrawerFocusClose
    })
  }

  function searchDrawerFocus() {
    searchFocus($(selectors.searchDrawerInput))

    if ($(selectors.mobileNavWrapper).hasClass(classes.mobileNavIsOpen)) {
      theme.MobileNav.closeMobileNav()
    }
  }

  function searchFocus($el) {
    $el.focus()
    // set selection range hack for iOS
    $el[0].setSelectionRange(0, $el[0].value.length)
  }

  function searchDrawerFocusClose() {
    $(selectors.siteHeaderSearchToggle).focus()
  }

  /**
   * Remove the aria-attributes and hide the error messages
   */
  function hideErrorMessage() {
    this.$searchErrorMessage.addClass(classes.hidden)
    this.$searchResultInput
      .removeAttr('aria-describedby')
      .removeAttr('aria-invalid')
  }

  /**
   * Add the aria-attributes and show the error messages
   */
  function showErrorMessage() {
    this.$searchErrorMessage.removeClass(classes.hidden)
    this.$searchResultInput
      .attr('aria-describedby', 'error-search-form')
      .attr('aria-invalid', true)
  }

  function validateSearchResultForm(evt) {
    const isInputValueEmpty = this.$searchResultInput.val().trim().length === 0

    if (!isInputValueEmpty) {
      hideErrorMessage.call(this)
      return
    }

    if (typeof evt !== 'undefined') {
      evt.preventDefault()
    }

    searchFocus(this.$searchResultInput)
    showErrorMessage.call(this)
  }

  return {
    init: init
  }
})();

(function () {
  const selectors = {
    backButton: '.return-link'
  }

  const $backButton = $(selectors.backButton)

  if (!document.referrer || !$backButton.length || !window.history.length) {
    return
  }

  $backButton.one('click', function (evt) {
    evt.preventDefault()

    const referrerDomain = urlDomain(document.referrer)
    const shopDomain = urlDomain(window.location.href)

    if (shopDomain === referrerDomain) {
      history.back()
    }

    return false
  })

  function urlDomain(url) {
    const anchor = document.createElement('a')
    anchor.ref = url

    return anchor.hostname
  }
})()

theme.Slideshow = (function () {
  this.$slideshow = null
  const classes = {
    slideshow: 'slideshow',
    slickActiveMobile: 'slick-active-mobile',
    controlsHover: 'slideshow__controls--hover',
    isPaused: 'is-paused'
  }

  const selectors = {
    section: '.shopify-section',
    wrapper: '#SlideshowWrapper-',
    slides: '.slideshow__slide',
    textWrapperMobile: '.slideshow__text-wrap--mobile',
    textContentMobile: '.slideshow__text-content--mobile',
    controls: '.slideshow__controls',
    pauseButton: '.slideshow__pause',
    dots: '.slick-dots',
    arrows: '.slideshow__arrows',
    arrowsMobile: '.slideshow__arrows--mobile',
    arrowLeft: '.slideshow__arrow-left',
    arrowRight: '.slideshow__arrow-right'
  }

  function slideshow(el, sectionId) {
    const $slideshow = (this.$slideshow = $(el))
    this.adaptHeight = this.$slideshow.data('adapt-height')
    this.$wrapper = this.$slideshow.closest(selectors.wrapper + sectionId)
    this.$section = this.$wrapper.closest(selectors.section)
    this.$controls = this.$wrapper.find(selectors.controls)
    this.$arrows = this.$section.find(selectors.arrows)
    this.$arrowsMobile = this.$section.find(selectors.arrowsMobile)
    this.$pause = this.$controls.find(selectors.pauseButton)
    this.$textWrapperMobile = this.$section.find(selectors.textWrapperMobile)
    this.autorotate = this.$slideshow.data('autorotate')
    const autoplaySpeed = this.$slideshow.data('speed')
    const loadSlideA11yString = this.$slideshow.data('slide-nav-a11y')

    this.settings = {
      accessibility: true,
      arrows: false,
      dots: true,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      autoplay: this.autorotate,
      autoplaySpeed: autoplaySpeed,
      // eslint-disable-next-line shopify/jquery-dollar-sign-reference
      appendDots: this.$arrows,
      customPaging: function (slick, index) {
        return (
          '<a href="' +
          selectors.wrapper +
          sectionId +
          '" aria-label="' +
          loadSlideA11yString.replace('[slide_number]', index + 1) +
          '" data-slide-number="' +
          index +
          '"></a>'
        )
      }
    }

    this.$slideshow.on('beforeChange', beforeChange.bind(this))
    this.$slideshow.on('init', slideshowA11ySetup.bind(this))

    // Add class to style mobile dots & show the correct text content for the
    // first slide on mobile when the slideshow initialises
    this.$slideshow.on(
      'init',
      function () {
        this.$mobileDots
          .find('li:first-of-type')
          .addClass(classes.slickActiveMobile)
        this.showMobileText(0)
      }.bind(this)
    )

    // Stop the autorotate when you scroll past the mobile controls, resume when
    // they are scrolled back into view
    if (this.autorotate) {
      $(document).scroll(
        $.debounce(
          250,
          function () {
            if (
              this.$arrowsMobile.offset().top +
              this.$arrowsMobile.outerHeight() <
              window.pageYOffset
            ) {
              $slideshow.slick('slickPause')
            } else if (!this.$pause.hasClass(classes.isPaused)) {
              $slideshow.slick('slickPlay')
            }
          }.bind(this)
        )
      )
    }

    if (this.adaptHeight) {
      this.setSlideshowHeight()
      $(window).resize($.debounce(50, this.setSlideshowHeight.bind(this)))
    }

    this.$slideshow.slick(this.settings)

    // This can't be called when the slick 'init' event fires due to how slick
    // adds a11y features.
    slideshowPostInitA11ySetup.bind(this)()

    this.$arrows.find(selectors.arrowLeft).on('click', function () {
      $slideshow.slick('slickPrev')
    })
    this.$arrows.find(selectors.arrowRight).on('click', function () {
      $slideshow.slick('slickNext')
    })

    this.$pause.on('click', this.togglePause.bind(this))
  }

  function slideshowA11ySetup(event, obj) {
    const $slider = obj.$slider
    const $list = obj.$list
    this.$dots = this.$section.find(selectors.dots)
    this.$mobileDots = this.$dots.eq(1)

    // Remove default Slick aria-live attr until slider is focused
    $list.removeAttr('aria-live')

    this.$wrapper.on('keyup', keyboardNavigation.bind(this))
    this.$controls.on('keyup', keyboardNavigation.bind(this))
    this.$textWrapperMobile.on('keyup', keyboardNavigation.bind(this))

    // When an element in the slider is focused
    // pause slideshow and set aria-live.
    this.$wrapper
      .on(
        'focusin',
        function (evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return
          }

          $list.attr('aria-live', 'polite')
          if (this.autorotate) {
            $slider.slick('slickPause')
          }
        }.bind(this)
      )
      .on(
        'focusout',
        function (evt) {
          if (!this.$wrapper.has(evt.target).length) {
            return
          }

          $list.removeAttr('aria-live')
          if (this.autorotate) {
            // Only resume playing if the user hasn't paused using the pause
            // button
            if (!this.$pause.is('.is-paused')) {
              $slider.slick('slickPlay')
            }
          }
        }.bind(this)
      )

    // Add arrow key support when focused
    if (this.$dots) {
      this.$dots
        .find('a')
        .each(function () {
          const $dot = $(this)
          $dot.on('click keyup', function (evt) {
            if (
              evt.type === 'keyup' &&
              evt.which !== slate.utils.keyboardKeys.ENTER
            ) { return }

            evt.preventDefault()

            const slideNumber = $(evt.target).data('slide-number')

            $slider.attr('tabindex', -1).slick('slickGoTo', slideNumber)

            if (evt.type === 'keyup') {
              $slider.focus()
            }
          })
        })
        .eq(0)
        .attr('aria-current', 'true')
    }

    this.$controls
      .on('focusin', highlightControls.bind(this))
      .on('focusout', unhighlightControls.bind(this))
  }

  function slideshowPostInitA11ySetup() {
    const $slides = this.$slideshow.find(selectors.slides)

    $slides.removeAttr('role').removeAttr('aria-labelledby')
    this.$dots
      .removeAttr('role')
      .find('li')
      .removeAttr('role')
      .removeAttr('aria-selected')
      .each(function () {
        const $dot = $(this)
        const ariaControls = $dot.attr('aria-controls')
        $dot
          .removeAttr('aria-controls')
          .find('a')
          .attr('aria-controls', ariaControls)
      })
  }

  function beforeChange(event, slick, currentSlide, nextSlide) {
    const $dotLinks = this.$dots.find('a')
    const $mobileDotLinks = this.$mobileDots.find('li')

    $dotLinks
      .removeAttr('aria-current')
      .eq(nextSlide)
      .attr('aria-current', 'true')

    $mobileDotLinks
      .removeClass(classes.slickActiveMobile)
      .eq(nextSlide)
      .addClass(classes.slickActiveMobile)
    this.showMobileText(nextSlide)
  }

  function keyboardNavigation() {
    if (event.keyCode === slate.utils.keyboardKeys.LEFTARROW) {
      this.$slideshow.slick('slickPrev')
    }
    if (event.keyCode === slate.utils.keyboardKeys.RIGHTARROW) {
      this.$slideshow.slick('slickNext')
    }
  }

  function highlightControls() {
    this.$controls.addClass(classes.controlsHover)
  }

  function unhighlightControls() {
    this.$controls.removeClass(classes.controlsHover)
  }

  slideshow.prototype.togglePause = function () {
    const slideshowSelector = getSlideshowId(this.$pause)
    if (this.$pause.hasClass(classes.isPaused)) {
      this.$pause.removeClass(classes.isPaused).attr('aria-pressed', 'false')
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPlay')
      }
    } else {
      this.$pause.addClass(classes.isPaused).attr('aria-pressed', 'true')
      if (this.autorotate) {
        $(slideshowSelector).slick('slickPause')
      }
    }
  }

  slideshow.prototype.setSlideshowHeight = function () {
    const minAspectRatio = this.$slideshow.data('min-aspect-ratio')
    this.$slideshow.height($(document).width() / minAspectRatio)
  }

  slideshow.prototype.showMobileText = function (slideIndex) {
    const $allTextContent = this.$textWrapperMobile.find(
      selectors.textContentMobile
    )
    const currentTextContentSelector =
      selectors.textContentMobile + '-' + slideIndex
    const $currentTextContent = this.$textWrapperMobile.find(
      currentTextContentSelector
    )
    if (
      !$currentTextContent.length &&
      this.$slideshow.find(selectors.slides).length === 1
    ) {
      this.$textWrapperMobile.hide()
    } else {
      this.$textWrapperMobile.show()
    }
    $allTextContent.hide()
    $currentTextContent.show()
  }

  function getSlideshowId($el) {
    return '#Slideshow-' + $el.data('id')
  }

  return slideshow
})()

// Youtube API callback
// eslint-disable-next-line no-unused-vars
function onYouTubeIframeAPIReady() {
  theme.Video.loadVideos()
}

theme.Video = (function () {
  let autoplayCheckComplete = false
  let autoplayAvailable = false
  let playOnClickChecked = false
  let playOnClick = false
  let youtubeLoaded = false
  const videos = {}
  const videoPlayers = []
  const videoOptions = {
    ratio: 16 / 9,
    scrollAnimationDuration: 400,
    playerVars: {
      // eslint-disable-next-line camelcase
      iv_load_policy: 3,
      modestbranding: 1,
      autoplay: 0,
      controls: 0,
      wmode: 'opaque',
      branding: 0,
      autohide: 0,
      rel: 0
    },
    events: {
      onReady: onPlayerReady,
      onStateChange: onPlayerChange
    }
  }
  const classes = {
    playing: 'video-is-playing',
    paused: 'video-is-paused',
    loading: 'video-is-loading',
    loaded: 'video-is-loaded',
    backgroundVideoWrapper: 'video-background-wrapper',
    videoWithImage: 'video--image_with_play',
    backgroundVideo: 'video--background',
    userPaused: 'is-paused',
    supportsAutoplay: 'autoplay',
    supportsNoAutoplay: 'no-autoplay',
    wrapperMinHeight: 'video-section-wrapper--min-height'
  }

  const selectors = {
    section: '.video-section',
    videoWrapper: '.video-section-wrapper',
    playVideoBtn: '.video-control__play',
    closeVideoBtn: '.video-control__close-wrapper',
    pauseVideoBtn: '.video__pause'
  }

  /**
   * Public functions
   */
  function init($video) {
    if (!$video.length) {
      return
    }

    videos[$video.attr('id')] = {
      id: $video.attr('id'),
      videoId: $video.data('id'),
      type: $video.data('type'),
      status:
        $video.data('type') === 'image_with_play' ? 'closed' : 'background', // closed, open, background
      $video: $video,
      $videoWrapper: $video.closest(selectors.videoWrapper),
      $section: $video.closest(selectors.section),
      controls: $video.data('type') === 'background' ? 0 : 1
    }

    if (!youtubeLoaded) {
      // This code loads the IFrame Player API code asynchronously.
      const tag = document.createElement('script')
      tag.src = 'https://www.youtube.com/iframe_api'
      const firstScriptTag = document.getElementsByTagName('script')[0]
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag)
    }

    playOnClickCheck()
  }

  function customPlayVideo(playerId) {
    // Make sure we have carried out the playOnClick check first
    if (!playOnClickChecked && !playOnClick) {
      return
    }

    if (playerId && typeof videoPlayers[playerId].playVideo === 'function') {
      privatePlayVideo(playerId)
    }
  }

  function pauseVideo(playerId) {
    if (
      videoPlayers[playerId] &&
      typeof videoPlayers[playerId].pauseVideo === 'function'
    ) {
      videoPlayers[playerId].pauseVideo()
    }
  }

  function loadVideos() {
    for (const key in videos) {
      if (videos.hasOwnProperty(key)) {
        createPlayer(key)
      }
    }

    initEvents()
    youtubeLoaded = true
  }

  function editorLoadVideo(key) {
    if (!youtubeLoaded) {
      return
    }
    createPlayer(key)

    initEvents()
  }

  /**
   * Private functions
   */

  function privatePlayVideo(id, clicked) {
    const videoData = videos[id]
    const player = videoPlayers[id]
    const $videoWrapper = videoData.$videoWrapper

    if (playOnClick) {
      // playOnClick means we are probably on mobile (no autoplay).
      // setAsPlaying will show the iframe, requiring another click
      // to play the video.
      setAsPlaying(videoData)
    } else if (clicked || (autoplayCheckComplete && autoplayAvailable)) {
      // Play if autoplay is available or clicked to play
      $videoWrapper.removeClass(classes.loading)
      setAsPlaying(videoData)
      player.playVideo()
      return
    }

    // Check for autoplay if not already done
    if (!autoplayCheckComplete) {
      autoplayCheckFunction(player, $videoWrapper)
    }
  }

  function setAutoplaySupport(supported) {
    const supportClass = supported
      ? classes.supportsAutoplay
      : classes.supportsNoAutoplay
    $(document.documentElement)
      .removeClass(classes.supportsAutoplay)
      .removeClass(classes.supportsNoAutoplay)
      .addClass(supportClass)

    if (!supported) {
      playOnClick = true
    } else {
      autoplayAvailable = true
    }

    autoplayCheckComplete = true
  }

  function autoplayCheckFunction(player, $videoWrapper) {
    // attempt to play video
    player.playVideo()

    autoplayTest(player)
      .then(function () {
        setAutoplaySupport(true)
      })
      .fail(function () {
        // No autoplay available (or took too long to start playing).
        // Show fallback image. Stop video for safety.
        setAutoplaySupport(false)
        player.stopVideo()
      })
      .always(function () {
        autoplayCheckComplete = true
        $videoWrapper.removeClass(classes.loading)
      })
  }

  function autoplayTest(player) {
    const deferred = $.Deferred()
    let wait
    let timeout

    wait = setInterval(function () {
      if (player.getCurrentTime() <= 0) {
        return
      }

      autoplayAvailable = true
      clearInterval(wait)
      clearTimeout(timeout)
      deferred.resolve()
    }, 500)

    timeout = setTimeout(function () {
      clearInterval(wait)
      deferred.reject()
    }, 4000) // subjective. test up to 8 times over 4 seconds

    return deferred
  }

  function playOnClickCheck() {
    // Bail early for a few instances:
    // - small screen
    // - device sniff mobile browser

    if (playOnClickChecked) {
      return
    }

    if (isMobile()) {
      playOnClick = true
    }

    if (playOnClick) {
      // No need to also do the autoplay check
      setAutoplaySupport(false)
    }

    playOnClickChecked = true
  }

  // The API will call this function when each video player is ready
  function onPlayerReady(evt) {
    evt.target.setPlaybackQuality('hd1080')
    const videoData = getVideoOptions(evt)
    playOnClickCheck()

    // Prevent tabbing through YouTube player controls until visible
    $('#' + videoData.id).attr('tabindex', '-1')

    sizeBackgroundVideos()

    // Customize based on options from the video ID
    if (videoData.type === 'background') {
      evt.target.mute()
      privatePlayVideo(videoData.id)
    }

    videoData.$videoWrapper.addClass(classes.loaded)
  }

  function onPlayerChange(evt) {
    const videoData = getVideoOptions(evt)
    switch (evt.data) {
      case YT.PlayerState.ENDED:
        setAsFinished(videoData)
        break
      case YT.PlayerState.PAUSED:
        // Seeking on a YouTube video also fires a PAUSED state change,
        // checking the state after a delay prevents us pausing the video when
        // the user is seeking instead of pausing
        setTimeout(function () {
          if (evt.target.getPlayerState() === YT.PlayerState.PAUSED) {
            setAsPaused(videoData)
          }
        }, 200)
        break
    }
  }

  function setAsFinished(videoData) {
    switch (videoData.type) {
      case 'background':
        videoPlayers[videoData.id].seekTo(0)
        break
      case 'image_with_play':
        closeVideo(videoData.id)
        toggleExpandVideo(videoData.id, false)
        break
    }
  }

  function setAsPlaying(videoData) {
    const $videoWrapper = videoData.$videoWrapper
    const $pauseButton = $videoWrapper.find(selectors.pauseVideoBtn)

    $videoWrapper.removeClass(classes.loading)

    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused)
    }

    // Do not change element visibility if it is a background video
    if (videoData.status === 'background') {
      return
    }

    $('#' + videoData.id).attr('tabindex', '0')

    if (videoData.type === 'image_with_play') {
      $videoWrapper.removeClass(classes.paused).addClass(classes.playing)
    }

    // Update focus to the close button so we stay within the video wrapper,
    // allowing time for the scroll animation
    setTimeout(function () {
      $videoWrapper.find(selectors.closeVideoBtn).focus()
    }, videoOptions.scrollAnimationDuration)
  }

  function setAsPaused(videoData) {
    const $videoWrapper = videoData.$videoWrapper

    // YT's events fire after our click event. This status flag ensures
    // we don't interact with a closed or background video.
    if (videoData.type === 'image_with_play') {
      if (videoData.status === 'closed') {
        $videoWrapper.removeClass(classes.paused)
      } else {
        $videoWrapper.addClass(classes.paused)
      }
    }

    $videoWrapper.removeClass(classes.playing)
  }

  function closeVideo(playerId) {
    const videoData = videos[playerId]
    const $videoWrapper = videoData.$videoWrapper
    const classesToRemove = [classes.paused, classes.playing].join(' ')

    if (isMobile()) {
      $videoWrapper.removeAttr('style')
    }

    $('#' + videoData.id).attr('tabindex', '-1')

    videoData.status = 'closed'

    switch (videoData.type) {
      case 'image_with_play':
        videoPlayers[playerId].stopVideo()
        setAsPaused(videoData) // in case the video is already paused
        break
      case 'background':
        videoPlayers[playerId].mute()
        setBackgroundVideo(playerId)
        break
    }

    $videoWrapper.removeClass(classesToRemove)
  }

  function getVideoOptions(evt) {
    return videos[evt.target.a.id]
  }

  function toggleExpandVideo(playerId, expand) {
    const video = videos[playerId]
    const elementTop = video.$videoWrapper.offset().top
    let offset = 0
    let newHeight = 0

    if (isMobile()) {
      video.$videoWrapper.parent().toggleClass('page-width', !expand)
    }

    if (expand) {
      if (isMobile()) {
        newHeight = $(window).width() / videoOptions.ratio
      } else {
        newHeight = video.$videoWrapper.width() / videoOptions.ratio
      }
      offset = ($(window).height() - newHeight) / 2

      video.$videoWrapper
        .removeClass(classes.wrapperMinHeight)
        .animate({ height: newHeight }, 600)

      // Animate doesn't work in mobile editor, so we don't use it
      if (!(isMobile() && Shopify.designMode)) {
        $('html, body').animate(
          {
            scrollTop: elementTop - offset
          },
          videoOptions.scrollAnimationDuration
        )
      }
    } else {
      if (isMobile()) {
        newHeight = video.$videoWrapper.data('mobile-height')
      } else {
        newHeight = video.$videoWrapper.data('desktop-height')
      }

      video.$videoWrapper
        .height(video.$videoWrapper.width() / videoOptions.ratio)
        .animate({ height: newHeight }, 600)
      setTimeout(function () {
        video.$videoWrapper.addClass(classes.wrapperMinHeight)
      }, 600)
    }
  }

  function togglePause(playerId) {
    const $pauseButton = videos[playerId].$videoWrapper.find(
      selectors.pauseVideoBtn
    )
    if ($pauseButton.hasClass(classes.userPaused)) {
      $pauseButton.removeClass(classes.userPaused)
      customPlayVideo(playerId)
    } else {
      $pauseButton.addClass(classes.userPaused)
      pauseVideo(playerId)
    }
  }

  function startVideoOnClick(playerId) {
    const video = videos[playerId]

    // add loading class to wrapper
    video.$videoWrapper.addClass(classes.loading)

    // Explicity set the video wrapper height (needed for height transition)
    video.$videoWrapper.attr(
      'style',
      'height: ' + video.$videoWrapper.height() + 'px'
    )

    video.status = 'open'

    switch (video.type) {
      case 'image_with_play':
        privatePlayVideo(playerId, true)
        break
      case 'background':
        unsetBackgroundVideo(playerId, video)
        videoPlayers[playerId].unMute()
        privatePlayVideo(playerId, true)
        break
    }

    toggleExpandVideo(playerId, true)

    // esc to close video player
    $(document).on('keydown.videoPlayer', function (evt) {
      const playerId = $(document.activeElement).data('controls')
      if (evt.keyCode !== slate.utils.keyboardKeys.ESCAPE || !playerId) {
        return
      }

      closeVideo(playerId)
      toggleExpandVideo(playerId, false)
    })
  }

  function sizeBackgroundVideos() {
    $('.' + classes.backgroundVideo).each(function (index, el) {
      sizeBackgroundVideo($(el))
    })
  }

  function sizeBackgroundVideo($videoPlayer) {
    if (!youtubeLoaded) {
      return
    }

    if (isMobile()) {
      $videoPlayer.removeAttr('style')
    } else {
      const $videoWrapper = $videoPlayer.closest(selectors.videoWrapper)
      const videoWidth = $videoWrapper.width()
      let playerWidth = $videoPlayer.width()
      let desktopHeight = $videoWrapper.data('desktop-height')

      // when screen aspect ratio differs from video, video must center and underlay one dimension
      if (videoWidth / videoOptions.ratio < desktopHeight) {
        playerWidth = Math.ceil(desktopHeight * videoOptions.ratio) // get new player width
        $videoPlayer
          .width(playerWidth)
          .height(desktopHeight)
          .css({
            left: (videoWidth - playerWidth) / 2,
            top: 0
          }) // player width is greater, offset left; reset top
      } else {
        // new video width < window width (gap to right)
        desktopHeight = Math.ceil(videoWidth / videoOptions.ratio) // get new player height
        $videoPlayer
          .width(videoWidth)
          .height(desktopHeight)
          .css({
            left: 0,
            top: (desktopHeight - desktopHeight) / 2
          }) // player height is greater, offset top; reset left
      }

      $videoPlayer.prepareTransition()
      $videoWrapper.addClass(classes.loaded)
    }
  }

  function unsetBackgroundVideo(playerId) {
    // Switch the background video to a chrome-only player once played
    $('#' + playerId)
      .removeClass(classes.backgroundVideo)
      .addClass(classes.videoWithImage)

    setTimeout(function () {
      $('#' + playerId).removeAttr('style')
    }, 600)

    videos[playerId].$videoWrapper
      .removeClass(classes.backgroundVideoWrapper)
      .addClass(classes.playing)

    videos[playerId].status = 'open'
  }

  function setBackgroundVideo(playerId) {
    $('#' + playerId)
      .removeClass(classes.videoWithImage)
      .addClass(classes.backgroundVideo)

    videos[playerId].$videoWrapper.addClass(classes.backgroundVideoWrapper)

    videos[playerId].status = 'background'
    sizeBackgroundVideo($('#' + playerId))
  }

  function isMobile() {
    return $(window).width() < 750 || window.mobileCheck()
  }

  function initEvents() {
    $(document).on('click.videoPlayer', selectors.playVideoBtn, function (evt) {
      const playerId = $(evt.currentTarget).data('controls')

      startVideoOnClick(playerId)
    })

    $(document).on('click.videoPlayer', selectors.closeVideoBtn, function (evt) {
      const playerId = $(evt.currentTarget).data('controls')

      $(evt.currentTarget).blur()
      closeVideo(playerId)
      toggleExpandVideo(playerId, false)
    })

    $(document).on('click.videoPlayer', selectors.pauseVideoBtn, function (evt) {
      const playerId = $(evt.currentTarget).data('controls')
      togglePause(playerId)
    })

    // Listen to resize to keep a background-size:cover-like layout
    $(window).on(
      'resize.videoPlayer',
      $.debounce(200, function () {
        if (!youtubeLoaded) return
        let key
        const fullscreen = window.innerHeight === screen.height

        sizeBackgroundVideos()

        if (isMobile()) {
          for (key in videos) {
            if (videos.hasOwnProperty(key)) {
              if (videos[key].$videoWrapper.hasClass(classes.playing)) {
                if (!fullscreen) {
                  pauseVideo(key)
                  setAsPaused(videos[key])
                }
              }
              videos[key].$videoWrapper.height(
                $(document).width() / videoOptions.ratio
              )
            }
          }
          setAutoplaySupport(false)
        } else {
          setAutoplaySupport(true)
          for (key in videos) {
            if (
              videos[key].$videoWrapper.find('.' + classes.videoWithImage)
                .length
            ) {
              continue
            }
            videoPlayers[key].playVideo()
            setAsPlaying(videos[key])
          }
        }
      })
    )

    $(window).on(
      'scroll.videoPlayer',
      $.debounce(50, function () {
        if (!youtubeLoaded) return

        for (const key in videos) {
          if (videos.hasOwnProperty(key)) {
            const $videoWrapper = videos[key].$videoWrapper

            // Close the video if more than 75% of it is scrolled out of view
            if (
              $videoWrapper.hasClass(classes.playing) &&
              ($videoWrapper.offset().top + $videoWrapper.height() * 0.75 <
                $(window).scrollTop() ||
                $videoWrapper.offset().top + $videoWrapper.height() * 0.25 >
                $(window).scrollTop() + $(window).height())
            ) {
              closeVideo(key)
              toggleExpandVideo(key, false)
            }
          }
        }
      })
    )
  }

  function createPlayer(key) {
    const args = $.extend({}, videoOptions, videos[key])
    args.playerVars.controls = args.controls
    videoPlayers[key] = new YT.Player(key, args)
  }

  function removeEvents() {
    $(document).off('.videoPlayer')
    $(window).off('.videoPlayer')
  }

  return {
    init: init,
    editorLoadVideo: editorLoadVideo,
    loadVideos: loadVideos,
    playVideo: customPlayVideo,
    pauseVideo: pauseVideo,
    removeEvents: removeEvents
  }
})()

window.theme = window.theme || {}

theme.FormStatus = (function () {
  const selectors = {
    statusMessage: '[data-form-status]'
  }

  function init() {
    this.$statusMessage = $(selectors.statusMessage)

    if (!this.$statusMessage) return

    this.$statusMessage.attr('tabindex', -1).focus()

    this.$statusMessage.on('blur', handleBlur.bind(this))
  }

  function handleBlur() {
    this.$statusMessage.removeAttr('tabindex')
  }

  return {
    init: init
  }
})();

/* ================ TEMPLATES ================ */
(function () {
  const $filterBy = $('#BlogTagFilter')

  if (!$filterBy.length) {
    return
  }

  $filterBy.on('change', function () {
    location.href = $(this).val()
  })
})()

window.theme = theme || {}

theme.customerTemplates = (function () {
  const selectors = {
    RecoverHeading: '#RecoverHeading',
    RecoverEmail: '#RecoverEmail',
    LoginHeading: '#LoginHeading'
  }

  function initEventListeners() {
    this.$RecoverHeading = $(selectors.RecoverHeading)
    this.$RecoverEmail = $(selectors.RecoverEmail)
    this.$LoginHeading = $(selectors.LoginHeading)

    // Show reset password form
    $('#RecoverPassword').on(
      'click',
      function (evt) {
        evt.preventDefault()
        showRecoverPasswordForm()
        this.$RecoverHeading.attr('tabindex', '-1').focus()
      }.bind(this)
    )

    // Hide reset password form
    $('#HideRecoverPasswordLink').on(
      'click',
      function (evt) {
        evt.preventDefault()
        hideRecoverPasswordForm()
        this.$LoginHeading.attr('tabindex', '-1').focus()
      }.bind(this)
    )

    this.$RecoverHeading.on('blur', function () {
      $(this).removeAttr('tabindex')
    })

    this.$LoginHeading.on('blur', function () {
      $(this).removeAttr('tabindex')
    })
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */

  function showRecoverPasswordForm() {
    $('#RecoverPasswordForm').removeClass('hide')
    $('#CustomerLoginForm').addClass('hide')

    if (this.$RecoverEmail.attr('aria-invalid') === 'true') {
      this.$RecoverEmail.focus()
    }
  }

  function hideRecoverPasswordForm() {
    $('#RecoverPasswordForm').addClass('hide')
    $('#CustomerLoginForm').removeClass('hide')
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    const $formState = $('.reset-password-success')

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return
    }

    // show success message
    $('#ResetSuccess')
      .removeClass('hide')
      .focus()
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    const $newAddressForm = $('#AddressNewForm')
    const $newAddressFormButton = $('#AddressNewButton')

    if (!$newAddressForm.length) {
      return
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(
        'AddressCountryNew',
        'AddressProvinceNew',
        {
          hideElement: 'AddressProvinceContainerNew'
        }
      )
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function () {
      const formId = $(this).data('form-id')
      const countrySelector = 'AddressCountry_' + formId
      const provinceSelector = 'AddressProvince_' + formId
      const containerSelector = 'AddressProvinceContainer_' + formId

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      })
    })

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function () {
      const isExpanded = $newAddressFormButton.attr('aria-expanded') === 'true'

      $newAddressForm.toggleClass('hide')
      $newAddressFormButton.attr('aria-expanded', !isExpanded).focus()
    })

    $('.address-edit-toggle').on('click', function () {
      const formId = $(this).data('form-id')
      const $editButton = $('#EditFormButton_' + formId)
      const $editAddress = $('#EditAddress_' + formId)
      const isExpanded = $editButton.attr('aria-expanded') === 'true'

      $editAddress.toggleClass('hide')
      $editButton.attr('aria-expanded', !isExpanded).focus()
    })

    $('.address-delete').on('click', function () {
      const $el = $(this)
      const formId = $el.data('form-id')
      const confirmMessage = $el.data('confirm-message')

      // eslint-disable-next-line no-alert
      if (
        confirm(
          confirmMessage || 'Are you sure you wish to delete this address?'
        )
      ) {
        Shopify.postLink('/account/addresses/' + formId, {
          parameters: { _method: 'delete' }
        })
      }
    })
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    const hash = window.location.hash

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      showRecoverPasswordForm.bind(this)()
    }
  }

  return {
    init: function () {
      initEventListeners()
      checkUrlHash()
      resetPasswordSuccess()
      customerAddressForm()
    }
  }
})()

/* ================ SECTIONS ================ */
window.theme = window.theme || {}

theme.Cart = (function () {
  const selectors = {
    edit: '.js-edit-toggle',
    inputQty: '.cart__qty-input',
    thumbnails: '.cart__image',
    item: '.cart__row'
  }

  const config = {
    showClass: 'cart__update--show',
    showEditClass: 'cart__edit--active',
    cartNoCookies: 'cart--no-cookies'
  }

  function Cart(container) {
    this.$container = $(container)
    this.$edit = $(selectors.edit, this.$container)
    this.$inputQuantities = $(selectors.inputQty, this.$container)
    this.$thumbnails = $(selectors.thumbnails, this.$container)

    if (!this.cookiesEnabled()) {
      this.$container.addClass(config.cartNoCookies)
    }

    this.$edit.on('click', this._onEditClick)
    this.$inputQuantities.on('change', this._handleInputQty)

    this.$thumbnails.css('cursor', 'pointer')
    this.$thumbnails.on('click', this._handleThumbnailClick)
  }

  Cart.prototype = _.assignIn({}, Cart.prototype, {
    onUnload: function () {
      this.$edit.off('click', this._onEditClick)
    },

    _onEditClick: function (evt) {
      const $evtTarget = $(evt.target)
      const $updateLine = $('.' + $evtTarget.data('target'))
      const isExpanded = $evtTarget.attr('aria-expanded') === 'true'

      $evtTarget
        .toggleClass(config.showEditClass)
        .attr('aria-expanded', !isExpanded)
      $updateLine.toggleClass(config.showClass)
    },

    _handleInputQty: function (evt) {
      const $input = $(evt.target)
      const value = $input.val()
      const itemKey = $input.data('quantity-item')
      const $itemQtyInputs = $('[data-quantity-item=' + itemKey + ']')
      $itemQtyInputs.val(value)
    },

    _handleThumbnailClick: function (evt) {
      const url = $(evt.target).data('item-url')

      window.location.href = url
    },

    cookiesEnabled: function () {
      let cookieEnabled = navigator.cookieEnabled

      if (!cookieEnabled) {
        document.cookie = 'testcookie'
        cookieEnabled = document.cookie.indexOf('testcookie') !== -1
      }
      return cookieEnabled
    }
  })

  return Cart
})()

window.theme = window.theme || {}

theme.Filters = (function () {
  const settings = {
    // Breakpoints from src/stylesheets/global/variables.scss.liquid
    mediaQueryMediumUp: 'screen and (min-width: 750px)'
  }

  const constants = {
    SORT_BY: 'sort_by'
  }

  const selectors = {
    mainContent: '#MainContent',
    filterSelection: '#FilterTags',
    sortSelection: '#SortBy'
  }

  const data = {
    sortBy: 'data-default-sortby'
  }

  function Filters(container) {
    const $container = (this.$container = $(container))

    this.$filterSelect = $(selectors.filterSelection, $container)
    this.$sortSelect = $(selectors.sortSelection, $container)
    this.$selects = $(selectors.filterSelection, $container).add(
      $(selectors.sortSelection, $container)
    )

    this.defaultSort = this._getDefaultSortValue()
    this.$selects.removeClass('hidden')

    this.$filterSelect.on('change', this._onFilterChange.bind(this))
    this.$sortSelect.on('change', this._onSortChange.bind(this))
    this._initBreakpoints()
  }

  Filters.prototype = _.assignIn({}, Filters.prototype, {
    _initBreakpoints: function () {
      const self = this

      enquire.register(settings.mediaQueryMediumUp, {
        match: function () {
          self._resizeSelect(self.$selects)
        }
      })
    },

    _onSortChange: function () {
      const sort = this._sortValue()
      const url = window.location.href.replace(window.location.search, '')
      const queryStringValue = slate.utils.getParameterByName('q')
      let query = queryStringValue !== null ? queryStringValue : ''

      if (sort.length) {
        const urlStripped = url.replace(window.location.hash, '')
        query = query !== '' ? '?q=' + query + '&' : '?'

        window.location.href =
          urlStripped + query + sort + selectors.mainContent
      } else {
        // clean up our url if the sort value is blank for default
        window.location.href = url
      }
    },

    _onFilterChange: function () {
      const filter = this._getFilterValue()

      // remove the 'page' parameter to go to the first page of results
      let search = document.location.search.replace(/\?(page=\w+)?&?/, '')

      // only add the search parameters to the url if they exist
      search = search !== '' ? '?' + search : ''

      document.location.href = filter + search + selectors.mainContent
    },

    _getFilterValue: function () {
      return this.$filterSelect.val()
    },

    _getSortValue: function () {
      return this.$sortSelect.val() || this.defaultSort
    },

    _getDefaultSortValue: function () {
      return this.$sortSelect.attr(data.sortBy)
    },

    _sortValue: function () {
      const sort = this._getSortValue()
      let query = ''

      if (sort !== this.defaultSort) {
        query = constants.SORT_BY + '=' + sort
      }

      return query
    },

    _resizeSelect: function ($selection) {
      $selection.each(function () {
        const $this = $(this)
        const arrowWidth = 10
        // create test element
        const text = $this.find('option:selected').text()
        const $test = $('<span>').html(text)

        // add to body, get width, and get out
        $test.appendTo('body')
        const width = $test.width()
        $test.remove()

        // set select width
        $this.width(width + arrowWidth)
      })
    },

    onUnload: function () {
      this.$filterSelect.off('change', this._onFilterChange)
      this.$sortSelect.off('change', this._onSortChange)
    }
  })

  return Filters
})()

window.theme = window.theme || {}

theme.HeaderSection = (function () {
  function Header() {
    theme.Header.init()
    theme.MobileNav.init()
    theme.Search.init()
  }

  Header.prototype = _.assignIn({}, Header.prototype, {
    onUnload: function () {
      theme.Header.unload()
    }
  })

  return Header
})()

theme.Maps = (function () {
  const config = {
    zoom: 14
  }
  let apiStatus = null
  const mapsToLoad = []

  const errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  }

  const selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  }

  const classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  }

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  // eslint-disable-next-line camelcase, no-unused-vars
  window.gm_authFailure = function () {
    if (!Shopify.designMode) {
      return
    }

    $(selectors.section).addClass(classes.mapError)
    $(selectors.map).remove()
    $(selectors.mapOverlay).after(
      '<div class="' +
      classes.errorMsg +
      '">' +
      theme.strings.authError +
      '</div>'
    )
  }

  function Map(container) {
    this.$container = $(container)
    this.$map = this.$container.find(selectors.map)
    this.key = this.$map.data('api-key')

    if (typeof this.key === 'undefined') {
      return
    }

    if (apiStatus === 'loaded') {
      this.createMap()
    } else {
      mapsToLoad.push(this)

      if (apiStatus !== 'loading') {
        apiStatus = 'loading'
        if (typeof window.google === 'undefined') {
          $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + this.key
          ).then(function () {
            apiStatus = 'loaded'
            initAllMaps()
          })
        }
      }
    }
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function (index, instance) {
      instance.createMap()
    })
  }

  function geolocate($map) {
    const deferred = $.Deferred()
    const geocoder = new google.maps.Geocoder()
    const address = $map.data('address-setting')

    geocoder.geocode({ address: address }, function (results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status)
      }

      deferred.resolve(results)
    })

    return deferred
  }

  Map.prototype = _.assignIn({}, Map.prototype, {
    createMap: function () {
      const $map = this.$map

      return geolocate($map)
        .then(
          function (results) {
            const mapOptions = {
              zoom: config.zoom,
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            }

            const map = (this.map = new google.maps.Map($map[0], mapOptions))
            const center = (this.center = map.getCenter())

            // eslint-disable-next-line no-unused-vars
            const marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            })

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function () {
                google.maps.event.trigger(map, 'resize')
                map.setCenter(center)
                $map.removeAttr('style')
              })
            )
          }.bind(this)
        )
        .fail(function () {
          let errorMessage

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults
              break
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit
              break
            case 'REQUEST_DENIED':
              errorMessage = errors.authError
              break
            default:
              errorMessage = errors.addressError
              break
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                classes.errorMsg +
                '">' +
                errorMessage +
                '</div>'
              )
          }
        })
    },

    onUnload: function () {
      if (this.$map.length === 0) {
        return
      }
      google.maps.event.clearListeners(this.map, 'resize')
    }
  })

  return Map
})()

/* eslint-disable no-new */
theme.Product = (function () {
  function Product(container) {
    const $container = (this.$container = $(container))
    const sectionId = $container.attr('data-section-id')

    this.settings = {
      // Breakpoints from src/stylesheets/global/variables.scss.liquid
      mediaQueryMediumUp: 'screen and (min-width: 750px)',
      mediaQuerySmall: 'screen and (max-width: 749px)',
      bpSmall: false,
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.slideshow-' + sectionId,
      sectionId: sectionId,
      sliderActive: false,
      zoomEnabled: false
    }

    this.selectors = {
      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,
      errorQuantityMessage: '#error-quantity-' + sectionId,
      quantity: '#Quantity-' + sectionId,
      SKU: '.variant-sku',
      productStatus: '[data-product-status]',
      originalSelectorId: '#ProductSelect-' + sectionId,
      productImageWraps: '.product-single__photo',
      productThumbImages: '.product-single__thumbnail--' + sectionId,
      productThumbs: '.product-single__thumbnails-' + sectionId,
      productThumbListItem: '.product-single__thumbnails-item',
      productFeaturedImage: '.product-featured-img',
      productThumbsWrapper: '.thumbnails-wrapper',
      saleLabel: '.product-price__sale-label-' + sectionId,
      singleOptionSelector: '.single-option-selector-' + sectionId,
      customOptionElements: '.custom-options-select, .custom-product-option-fieldset:not([disabled])',
      shopifyPaymentButton: '.shopify-payment-button',
      priceContainer: '[data-price]',
      regularPrice: '[data-regular-price]',
      salePrice: '[data-sale-price]',
      atcPrice: '[data-atc-price]'
    }

    this.classes = {
      hidden: 'hide',
      productOnSale: 'price--on-sale',
      productUnavailable: 'price--unavailable',
      activeClass: 'active-thumb'
    }

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$('#ProductJson-' + sectionId).html()) {
      return
    }

    this.productSingleObject = JSON.parse(
      document.getElementById('ProductJson-' + sectionId).innerHTML
    )

    this.settings.zoomEnabled = $(this.selectors.productImageWraps).hasClass(
      'js-zoom-enabled'
    )

    this._initBreakpoints()
    this._stringOverrides()
    this._initVariants()
    this._initImageSwitch()
    this._initAddToCart()
    this._setActiveThumbnail()
    this._initCustomPrice()
    this._initCustomOptionListeners()
  }

  Product.prototype = _.assignIn({}, Product.prototype, {
    _stringOverrides: function () {
      theme.productStrings = theme.productStrings || {}
      $.extend(theme.strings, theme.productStrings)
    },

    _initBreakpoints: function () {
      const self = this

      enquire.register(this.settings.mediaQuerySmall, {
        match: function () {
          // initialize thumbnail slider on mobile if more than three thumbnails
          if ($(self.selectors.productThumbImages).length > 3) {
            self._initThumbnailSlider()
          }

          // destroy image zooming if enabled
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _destroyZoom(this)
            })
          }

          self.settings.bpSmall = true
        },
        unmatch: function () {
          if (self.settings.sliderActive) {
            self._destroyThumbnailSlider()
          }

          self.settings.bpSmall = false
        }
      })

      enquire.register(this.settings.mediaQueryMediumUp, {
        match: function () {
          if (self.settings.zoomEnabled) {
            $(self.selectors.productImageWraps).each(function () {
              _enableZoom(this)
            })
          }
        }
      })
    },

    _initVariants: function () {
      const options = {
        $container: this.$container,
        enableHistoryState:
          this.$container.data('enable-history-state') || false,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productSingleObject
      }

      this.variants = new slate.Variants(options)

      this.$container.on(
        'variantChange' + this.settings.namespace,
        this._updateAvailability.bind(this)
      )
      this.$container.on(
        'variantImageChange' + this.settings.namespace,
        this._updateImages.bind(this)
      )
      this.$container.on(
        'variantPriceChange' + this.settings.namespace,
        this._updatePrice.bind(this),
      )
      this.$container.on(
        'variantSKUChange' + this.settings.namespace,
        this._updateSKU.bind(this)
      )
    },

    _initCustomPrice: function () {
      // get variant and custom option prices - update atc price
      const $priceContainer = $(this.selectors.priceContainer, this.$container)
      const $regularPrice = $(this.selectors.regularPrice, $priceContainer)
      const $salePrice = $(this.selectors.salePrice, $priceContainer)
      const $atcPrice = $(this.selectors.atcPrice, this.$container)

      // Reset price states
      $atcPrice?.addClass('loading').removeClass('loaded')
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden')

      const variant = this.variants.currentVariant
      const customOptions = document.querySelectorAll('.custom-options-select option:checked, .custom-product-option-fieldset:not([disabled]) input:checked')

      if (!variant || !customOptions) return
      let customCompareOptionPriceTotal = 0
      let customOptionPriceTotal = 0
      customOptions.forEach(product => {
        const price = product.getAttribute('data-price')
        const comparePrice = product.getAttribute('data-compare-price')
        if (price == '' || !price) return
        customCompareOptionPriceTotal = customCompareOptionPriceTotal + (comparePrice ? parseInt(comparePrice) : parseInt(price))
        customOptionPriceTotal += parseInt(price)
      })

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price + (customCompareOptionPriceTotal > customOptionPriceTotal ? customCompareOptionPriceTotal : customOptionPriceTotal),
            theme.moneyFormat
          )
        )
        $salePrice.html(
          theme.Currency.formatMoney(variant.price + customOptionPriceTotal, theme.moneyFormat)
        )
        $priceContainer.addClass(this.classes.productOnSale)
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price + (customCompareOptionPriceTotal > customOptionPriceTotal ? customCompareOptionPriceTotal : customOptionPriceTotal), theme.moneyFormat)
        )
      }
      // Add to Cart button price
      if (!$atcPrice) return
      // show discounted price if discount set
      const discountPercentage = $atcPrice.attr('data-discount-percentage')
      if (discountPercentage) {
        const discountedPrice = variant.price * discountPercentage
        $atcPrice.html(
          theme.Currency.formatMoney(discountedPrice + customOptionPriceTotal, theme.moneyFormat) + `<span class="tw-line-through tw-pl-2 tw-opacity-70">${theme.Currency.formatMoney(variant.price + (customCompareOptionPriceTotal > customOptionPriceTotal ? customCompareOptionPriceTotal : customOptionPriceTotal), theme.moneyFormat)}</span>`
        )
        $atcPrice.addClass('loaded').remove('loading')
        return
      }
      $atcPrice.html(
        theme.Currency.formatMoney(variant.price + customOptionPriceTotal, theme.moneyFormat)
      )
      $atcPrice.addClass('loaded').remove('loading')
    },

    _initCustomOptionListeners() {
      const customOptions = document.querySelectorAll(this.selectors.customOptionElements)
      if (!customOptions) return
      customOptions.forEach(customOption => {
        customOption.addEventListener('change', this._initCustomPrice.bind(this))
      })
    },

    _initImageSwitch: function () {
      if (!$(this.selectors.productThumbImages).length) {
        return
      }

      const self = this

      $(this.selectors.productThumbImages)
        .on('click', function (evt) {
          //         evt.preventDefault();
          //         var $el = $(this);

          //         var imageId = $el.data('thumbnail-id');

          //         self._switchImage(imageId);
          //         self._setActiveThumbnail(imageId);
        })
        .on('keyup', self._handleImageFocus.bind(self))
    },

    _initAddToCart: function () {
      const self = this
      const $quantityInput = $(self.selectors.quantity)

      if ($quantityInput.length === 0) return

      $(self.selectors.addToCart).on('click', function (evt) {
        const isInvalidQuantity = $quantityInput.val() <= 0

        $(self.selectors.errorQuantityMessage).toggleClass(
          self.classes.hidden,
          !isInvalidQuantity
        )

        if (isInvalidQuantity) {
          $quantityInput
            .attr(
              'aria-describedby',
              'error-quantity-' + self.settings.sectionId
            )
            .attr('aria-invalid', true)
          $(self.selectors.errorQuantityMessage).focus()
          evt.preventDefault()
        } else {
          $quantityInput
            .removeAttr('aria-describedby')
            .removeAttr('aria-invalid')
        }
      })
    },

    _setActiveThumbnail: function (imageId) {
      // Change SRC for Tablet/Desktop
      if (window.matchMedia('(min-width: 481px)').matches) {
        // If there is no element passed, find it by the current product image
        if (typeof imageId === 'undefined') {
          imageId = $(
            this.selectors.productImageWraps + ':not(.hide)',
            this.$container
          ).data('image-id')
        }

        const $thumbnailWrappers = $(
          this.selectors.productThumbListItem + ':not(.slick-cloned)',
          this.$container
        )

        const $activeThumbnail = $thumbnailWrappers.find(
          this.selectors.productThumbImages +
          "[data-thumbnail-id='" +
          imageId +
          "']"
        )

        $(this.selectors.productThumbImages)
          .removeClass(this.classes.activeClass)
          .removeAttr('aria-current')

        $activeThumbnail.addClass(this.classes.activeClass)
        $activeThumbnail.attr('aria-current', true)

        if (!$thumbnailWrappers.hasClass('slick-slide')) {
          return
        }

        const slideIndex = $activeThumbnail.parent().data('slick-index')

        $(this.selectors.productThumbs).slick('slickGoTo', slideIndex, true)

        // Change slider for Mobile.
      } else {
        if (jQuery('.product-main-image-inner.mobile.slick-initialized').length) {
          const slickIndex = parseInt(jQuery('.product-main-image-inner.mobile .product-single__photo[data-image-id="' + imageId + '"]').closest('.slick-slide').attr('data-slick-index'))
          jQuery('.product-main-image-inner.mobile').slick('slickGoTo', slickIndex)
        }
      }
    },

    _switchImage: function (imageId) {
      // Change SRC for Tablet/Desktop
      if (window.matchMedia('(min-width: 481px)').matches) {
        const $newImage = $(
          this.selectors.productImageWraps + "[data-image-id='" + imageId + "']",
          this.$container
        )
        const $otherImages = $(
          this.selectors.productImageWraps +
          ":not([data-image-id='" +
          imageId +
          "'])",
          this.$container
        )

        $newImage.removeClass(this.classes.hidden)
        $otherImages.addClass(this.classes.hidden)
      }
    },

    _handleImageFocus: function (evt) {
      if (evt.keyCode !== slate.utils.keyboardKeys.ENTER) return

      $(this.selectors.productFeaturedImage + ':visible').focus()
    },

    _initThumbnailSlider: function () {
      const options = {
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: false,
        prevArrow: '.thumbnails-slider__prev--' + this.settings.sectionId,
        nextArrow: '.thumbnails-slider__next--' + this.settings.sectionId,
        responsive: [
          {
            breakpoint: 321,
            settings: {
              slidesToShow: 3
            }
          }
        ]
      }

      // $(this.selectors.productThumbs).slick(options);

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-list')
        .removeAttr('aria-live')
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('.slick-disabled')
        .removeAttr('aria-disabled')

      this.settings.sliderActive = true
    },

    _destroyThumbnailSlider: function () {
      $(this.selectors.productThumbs).slick('unslick')
      this.settings.sliderActive = false

      // Accessibility concerns not yet fixed in Slick Slider
      $(this.selectors.productThumbsWrapper, this.$container)
        .find('[tabindex="-1"]')
        .removeAttr('tabindex')
    },

    _liveRegionText: function (variant) {
      // Dummy content for live region
      let liveRegionText = '[Availability] [Regular] [$$] [Sale] [$]'

      if (!variant) {
        liveRegionText = theme.strings.unavailable
        return liveRegionText
      }

      // Update availability
      const availability = variant.available ? '' : theme.strings.soldOut + ','

      liveRegionText = liveRegionText.replace('[Availability]', availability)

      // Update pricing information
      let regularLabel = ''
      let regularPrice = theme.Currency.formatMoney(
        variant.price,
        theme.moneyFormat
      )
      let saleLabel = ''
      let salePrice = ''

      if (variant.compare_at_price > variant.price) {
        regularLabel = theme.strings.regularPrice
        regularPrice =
          theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.moneyFormat
          ) + ','
        saleLabel = theme.strings.sale
        salePrice = theme.Currency.formatMoney(
          variant.price,
          theme.moneyFormat
        )
      }

      liveRegionText = liveRegionText
        .replace('[Regular]', regularLabel)
        .replace('[$$]', regularPrice)
        .replace('[Sale]', saleLabel)
        .replace('[$]', salePrice)
        .trim()

      return liveRegionText
    },

    _updateLiveRegion: function (evt) {
      const variant = evt.variant
      const liveRegion = this.container.querySelector(
        this.selectors.productStatus
      )
      liveRegion.textContent = this._liveRegionText(variant)
      liveRegion.setAttribute('aria-hidden', false)

      // hide content from accessibility tree after announcement
      setTimeout(function () {
        liveRegion.setAttribute('aria-hidden', true)
      }, 1000)
    },

    _updateAddToCart: function (evt) {
      let isRestricted = false
      const userLoc = document.querySelector('localization-form input[name="country_code"]').value
      const groups = window.theme.locations

      const productId = evt.product.id
      const prodRestrict = document.querySelector(`[data-restriction-product="${productId}"]`)
      const prodRestrictCountries = prodRestrict?.getAttribute('data-restriction-countries')
      if (prodRestrict && (prodRestrictCountries.includes(userLoc) || (groups.EU.includes(userLoc) && prodRestrictCountries.includes('EU')) || (!groups.GLOBALEXCLUDE.includes(userLoc) && prodRestrictCountries.includes('GLOBAL')))) {
        isRestricted = true
      }

      if (isRestricted) {
        $(this.selectors.addToCart).prop('disabled', true)
        $(this.selectors.addToCartText).text('Not available in your region')
        $(this.selectors.shopifyPaymentButton, this.$container).hide()
        return
      }

      const variant = evt.variant
      const skuRestrict = document.querySelector(`[data-restriction-sku="${variant.sku}"]`)
      const skuRestrictCountries = skuRestrict.getAttribute('data-restriction-countries')

      if (skuRestrict && (skuRestrictCountries.includes(userLoc) || (groups.EU.includes(userLoc) && skuRestrictCountries.includes('EU')) || (!groups.GLOBALEXCLUDE.includes(userLoc) && skuRestrictCountries.includes('GLOBAL')))) {
        isRestricted = true
      }

      if (variant) {
        // check if there's a sku-level metafield restriction by location
        if (isRestricted) {
          $(this.selectors.addToCart).prop('disabled', true)
          $(this.selectors.addToCartText).text('SOLD OUT')
          $(this.selectors.shopifyPaymentButton, this.$container).hide()
          return
        }

        // regular availability check
        if (variant.available) {
          $(this.selectors.addToCart).prop('disabled', false)
          $(this.selectors.addToCartText).text(theme.strings.addToCart)
          $(this.selectors.shopifyPaymentButton, this.$container).show()
        } else {
          // The variant doesn't exist, disable submit button and change the text.
          // This may be an error or notice that a specific variant is not available.
          $(this.selectors.addToCart).prop('disabled', true)
          $(this.selectors.addToCartText).text(theme.strings.soldOut)
          $(this.selectors.shopifyPaymentButton, this.$container).hide()
        }
      } else {
        $(this.selectors.addToCart).prop('disabled', true)
        $(this.selectors.addToCartText).text(theme.strings.unavailable)
        $(this.selectors.shopifyPaymentButton, this.$container).hide()
      }
    },

    _updateAvailability: function (evt) {
      // update form submit
      this._updateAddToCart(evt)
      // update live region
      this._updateLiveRegion(evt)

      this._updatePrice(evt)
            this._initCustomPrice()
      // Remove "From" prefix after variant change - it should only show on initial page load
    //  this.$container.find('[data-from-initial]').remove()

    },

    _updateImages: function (evt) {
      const variant = evt.variant
      const imageId = variant.featured_image.id

      this._switchImage(imageId)
      this._setActiveThumbnail(imageId)
    },

    _updatePrice: function (evt) {
      const variant = evt.variant

      const $priceContainer = $(this.selectors.priceContainer, this.$container)
      const $regularPrice = $(this.selectors.regularPrice, $priceContainer)
      const $salePrice = $(this.selectors.salePrice, $priceContainer)
      const $atcPrice = $(this.selectors.atcPrice, this.$container)

      // Reset product price state
      $priceContainer
        .removeClass(this.classes.productUnavailable)
        .removeClass(this.classes.productOnSale)
        .removeAttr('aria-hidden')

      // Unavailable
      if (!variant) {
        $priceContainer
          .addClass(this.classes.productUnavailable)
          .attr('aria-hidden', true)
        return
      }

      // Check for custom option prices.
      let customCompareOptionPriceTotal = 0
      let customOptionPriceTotal = 0
      const customOptions = document.querySelectorAll('.custom-options-select option:checked, .custom-product-option-fieldset:not([disabled]) input:checked')
      if (customOptions) {
        customOptions.forEach(product => {
          const price = product.getAttribute('data-price')
          const comparePrice = product.getAttribute('data-compare-price')
          if (price == '' || !price) return
          customCompareOptionPriceTotal = customCompareOptionPriceTotal + (comparePrice ? parseInt(comparePrice) : parseInt(price))
          customOptionPriceTotal += parseInt(price)
        })
      }

      // On sale
      if (variant.compare_at_price > variant.price) {
        $regularPrice.html(
          theme.Currency.formatMoney(
            variant.compare_at_price + (customCompareOptionPriceTotal > customOptionPriceTotal ? customCompareOptionPriceTotal : customOptionPriceTotal),
            theme.moneyFormat
          )
        )
        $salePrice.html(
          theme.Currency.formatMoney(variant.price + customOptionPriceTotal, theme.moneyFormat)
        )
        $priceContainer.addClass(this.classes.productOnSale)
      } else {
        // Regular price
        $regularPrice.html(
          theme.Currency.formatMoney(variant.price + (customCompareOptionPriceTotal > customOptionPriceTotal ? customCompareOptionPriceTotal : customOptionPriceTotal), theme.moneyFormat)
        )
      }
      // show discounted price if discount set
      const discountPercentage = $atcPrice.attr('data-discount-percentage')
      if (discountPercentage) {
        const discountedPrice = variant.price * discountPercentage
        $atcPrice.html(
          theme.Currency.formatMoney(discountedPrice + customOptionPriceTotal, theme.moneyFormat) + `<span class="tw-line-through tw-pl-2 tw-opacity-70">${theme.Currency.formatMoney(variant.price + (customCompareOptionPriceTotal > customOptionPriceTotal ? customCompareOptionPriceTotal : customOptionPriceTotal), theme.moneyFormat)}</span>`
        )
        $atcPrice.addClass('loaded').remove('loading')
        return
      }
      $atcPrice.html(
        theme.Currency.formatMoney(variant.price + customOptionPriceTotal, theme.moneyFormat)
      )
    },

    _updateSKU: function (evt) {
      const variant = evt.variant

      // Update the sku
      $(this.selectors.SKU).html(variant.sku)
    },

    onUnload: function () {
      this.$container.off(this.settings.namespace)
    }
  })

  function _enableZoom(el) {
    const zoomUrl = $(el).data('zoom')
    $(el).zoom({
      url: zoomUrl
    })
  }

  function _destroyZoom(el) {
    $(el).trigger('zoom.destroy')
  }

  return Product
})()

theme.Quotes = (function () {
  const config = {
    mediaQuerySmall: 'screen and (max-width: 749px)',
    mediaQueryMediumUp: 'screen and (min-width: 750px)',
    slideCount: 0
  }
  const defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  }

  function Quotes(container) {
    const $container = (this.$container = $(container))
    const sectionId = $container.attr('data-section-id')
    const wrapper = (this.wrapper = '.quotes-wrapper')
    const slider = (this.slider = '#Quotes-' + sectionId)
    const $slider = $(slider, wrapper)

    let sliderActive = false
    const mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    })

    config.slideCount = $slider.data('count')

    // Override slidesToShow/Scroll if there are not enough blocks
    if (config.slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = config.slideCount
      defaults.slidesToScroll = config.slideCount
    }

    $slider.on('init', this.a11y.bind(this))

    enquire.register(config.mediaQuerySmall, {
      match: function () {
        initSlider($slider, mobileOptions)
      }
    })

    enquire.register(config.mediaQueryMediumUp, {
      match: function () {
        initSlider($slider, defaults)
      }
    })

    function initSlider(sliderObj, args) {
      if (sliderActive) {
        sliderObj.slick('unslick')
        sliderActive = false
      }

      sliderObj.slick(args)
      sliderActive = true
    }
  }

  Quotes.prototype = _.assignIn({}, Quotes.prototype, {
    onUnload: function () {
      enquire.unregister(config.mediaQuerySmall)
      enquire.unregister(config.mediaQueryMediumUp)

      $(this.slider, this.wrapper).slick('unslick')
    },

    onBlockSelect: function (evt) {
      // Ignore the cloned version
      const $slide = $(
        '.quotes-slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      )
      const slideIndex = $slide.data('slick-index')

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex)
    },

    a11y: function (event, obj) {
      const $list = obj.$list
      const $wrapper = $(this.wrapper, this.$container)

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live')

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite')
        }
      })

      // Remove aria-live
      $wrapper.on('focusout', function (evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live')
        }
      })
    }
  })

  return Quotes
})()

theme.slideshows = {}

theme.SlideshowSection = (function () {
  function SlideshowSection(container) {
    const $container = (this.$container = $(container))
    const sectionId = $container.attr('data-section-id')
    const slideshow = (this.slideshow = '#Slideshow-' + sectionId)

    theme.slideshows[slideshow] = new theme.Slideshow(slideshow, sectionId)
  }

  return SlideshowSection
})()

theme.SlideshowSection.prototype = _.assignIn(
  {},
  theme.SlideshowSection.prototype,
  {
    onUnload: function () {
      delete theme.slideshows[this.slideshow]
    },

    onBlockSelect: function (evt) {
      const $slideshow = $(this.slideshow)
      const adaptHeight = $slideshow.data('adapt-height')

      if (adaptHeight) {
        theme.slideshows[this.slideshow].setSlideshowHeight()
      }

      // Ignore the cloned version
      const $slide = $(
        '.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)'
      )
      const slideIndex = $slide.data('slick-index')

      // Go to selected slide, pause auto-rotate
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause')
    },

    onBlockDeselect: function () {
      // Resume auto-rotate
      $(this.slideshow).slick('slickPlay')
    }
  }
)

theme.slideshows = {}

theme.VideoSection = (function () {
  function VideoSection(container) {
    const $container = (this.$container = $(container))

    $('.video', $container).each(function () {
      const $el = $(this)
      theme.Video.init($el)
      theme.Video.editorLoadVideo($el.attr('id'))
    })
  }

  return VideoSection
})()

theme.VideoSection.prototype = _.assignIn({}, theme.VideoSection.prototype, {
  onUnload: function () {
    theme.Video.removeEvents()
  }
})

$(document).ready(function () {
  const sections = new theme.Sections()

  sections.register('cart-template', theme.Cart)
  sections.register('product', theme.Product)
  sections.register('collection-template', theme.Filters)
  sections.register('product-template', theme.Product)
  sections.register('header-section', theme.HeaderSection)
  sections.register('map', theme.Maps)
  sections.register('slideshow-section', theme.SlideshowSection)
  sections.register('video-section', theme.VideoSection)
  sections.register('quotes', theme.Quotes)
})

theme.init = function () {
  theme.customerTemplates.init()

  // Theme-specific selectors to make tables scrollable
  const tableSelectors = '.rte table,' + '.custom__item-inner--html table'

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'scrollable-wrapper'
  })

  // Theme-specific selectors to make iframes responsive
  const iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"],' +
    '.custom__item-inner--html iframe[src*="youtube.com/embed"],' +
    '.custom__item-inner--html iframe[src*="player.vimeo"]'

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'video-wrapper'
  })

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash))

  $('.in-page-link').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash))
  })

  $('a[href="#"]').on('click', function (evt) {
    evt.preventDefault()
  })

  slate.a11y.accessibleLinks({
    messages: {
      newWindow: theme.strings.newWindow,
      external: theme.strings.external,
      newWindowExternal: theme.strings.newWindowExternal
    },
    $links: $('a[href]:not([aria-describedby], .product-single__thumbnail)')
  })

  theme.FormStatus.init()
}

$(theme.init)

/* Global functions from Dawn */
function debounce(fn, wait) {
  let t
  return (...args) => {
    clearTimeout(t)
    t = setTimeout(() => fn.apply(this, args), wait)
  }
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  )

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    )
  })

  if (summary.closest('header-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container)
  const first = elements[0]
  const last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) { return }

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}

class MenuDrawer extends HTMLElement {
  constructor() {
    super()

    this.mainDetailsToggle = this.querySelector('details')

    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.addEventListener('focusout', this.onFocusOut.bind(this))
    this.bindEvents()
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    )
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    )
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return

    const openDetailsElement = event.target.closest('details[open]')
    if (!openDetailsElement) return

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector('summary')
      )
      : this.closeSubmenu(openDetailsElement)
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget
    const detailsElement = summaryElement.parentNode
    const parentMenuElement = detailsElement.closest('.has-submenu')
    const isOpen = detailsElement.hasAttribute('open')
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      )
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      )
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault()
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement)

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        )
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening')
        summaryElement.setAttribute('aria-expanded', true)
        parentMenuElement && parentMenuElement.classList.add('submenu-open')
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            'transitionend',
            addTrapFocus
          )
      }, 100)
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening')
    })
    summaryElement.setAttribute('aria-expanded', true)
    trapFocus(this.mainDetailsToggle, summaryElement)
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`)
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return

    this.mainDetailsToggle.classList.remove('menu-opening')
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open')
      details.classList.remove('menu-opening')
    })
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open')
      })
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    )
    removeTrapFocus(elementToFocus)
    this.closeAnimation(this.mainDetailsToggle)
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      ) { this.closeMenuDrawer() }
    })
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details')
    this.closeSubmenu(detailsElement)
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open')
    parentMenuElement && parentMenuElement.classList.remove('submenu-open')
    detailsElement.classList.remove('menu-opening')
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false)
    removeTrapFocus(detailsElement.querySelector('summary'))
    this.closeAnimation(detailsElement)
  }

  closeAnimation(detailsElement) {
    let animationStart

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time
      }

      const elapsedTime = time - animationStart

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation)
      } else {
        detailsElement.removeAttribute('open')
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          )
        }
      }
    }

    window.requestAnimationFrame(handleAnimation)
  }
}

customElements.define('menu-drawer', MenuDrawer)

/* POPUP CORE CODE */
!(function (t) { let e; let o; const i = t(window); let n = {}; const a = []; const s = []; let p = null; const l = []; let d = null; const r = /(iPad|iPhone|iPod)/g.test(navigator.userAgent); var c = { _init: function (e) { const o = t(e); const i = o.data('popupoptions'); s[e.id] = !1, a[e.id] = 0, o.data('popup-initialized') || (o.attr('data-popup-initialized', 'true'), c._initonce(e)), i.autoopen && setTimeout(function () { c.show(e, 0) }, 0) }, _initonce: function (o) { let i; let n; const a = t(o); const s = t('body'); const l = a.data('popupoptions'); if (p = parseInt(s.css('margin-right'), 10), d = void 0 !== document.body.style.webkitTransition || void 0 !== document.body.style.MozTransition || void 0 !== document.body.style.msTransition || void 0 !== document.body.style.OTransition || void 0 !== document.body.style.transition, l.type == 'tooltip' && (l.background = !1, l.scrolllock = !1), l.backgroundactive && (l.background = !1, l.blur = !1, l.scrolllock = !1), l.scrolllock) { let u, f; void 0 === e && (f = (u = t('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo('body')).children(), e = f.innerWidth() - f.height(99).innerWidth(), u.remove()) } if (a.attr('id') || a.attr('id', 'j-popup-' + parseInt(1e8 * Math.random(), 10)), a.addClass('popup_content'), l.background && !t('#' + o.id + '_background').length) { s.append('<div id="' + o.id + '_background" class="popup_background"></div>'); const h = t('#' + o.id + '_background'); h.css({ opacity: 0, visibility: 'hidden', backgroundColor: l.color, position: 'fixed', top: 0, right: 0, bottom: 0, left: 0 }), l.setzindex && !l.autozindex && h.css('z-index', '100000'), l.transition && h.css('transition', l.transition) } s.append(o), a.wrap('<div id="' + o.id + '_wrapper" class="popup_wrapper" />'), (i = t('#' + o.id + '_wrapper')).css({ opacity: 0, visibility: 'hidden', position: 'absolute' }), r && i.css('cursor', 'pointer'), l.type == 'overlay' && i.css('overflow', 'auto'), a.css({ opacity: 0, visibility: 'hidden', display: 'inline-block' }), l.setzindex && !l.autozindex && i.css('z-index', '100001'), l.outline || a.css('outline', 'none'), l.transition && (a.css('transition', l.transition), i.css('transition', l.transition)), a.attr('aria-hidden', !0), l.type == 'overlay' && (a.css({ textAlign: 'left', position: 'relative', verticalAlign: 'middle' }), n = { position: 'fixed', width: '100%', height: '100%', top: 0, left: 0, textAlign: 'center' }, l.backgroundactive && (n.position = 'absolute', n.height = '0', n.overflow = 'visible'), i.css(n), i.append('<div class="popup_align" />'), t('.popup_align').css({ display: 'inline-block', verticalAlign: 'middle', height: '100%' })), a.attr('role', 'dialog'); const b = l.openelement ? l.openelement : '.' + o.id + '_open'; t(b).each(function (e, o) { t(o).attr('data-popup-ordinal', e), o.id || t(o).attr('id', 'open_' + parseInt(1e8 * Math.random(), 10)) }), a.attr('aria-labelledby') || a.attr('aria-label') || a.attr('aria-labelledby', t(b).attr('id')), l.action == 'hover' ? (l.keepfocus = !1, t(b).on('mouseenter', function (e) { c.show(o, t(this).data('popup-ordinal')) }), t(b).on('mouseleave', function (t) { c.hide(o) })) : t(document).on('click', b, function (e) { e.preventDefault(); const i = t(this).data('popup-ordinal'); setTimeout(function () { c.show(o, i) }, 0) }), l.closebutton && c.addclosebutton(o), l.detach ? a.hide().detach() : i.hide() }, show: function (n, r) { const f = t(n); if (!f.data('popup-visible')) { f.data('popup-initialized') || c._init(n), f.attr('data-popup-initialized', 'true'); const h = t('body'); const b = f.data('popupoptions'); const v = t('#' + n.id + '_wrapper'); const g = t('#' + n.id + '_background'); if (u(n, r, b.beforeopen), s[n.id] = r, setTimeout(function () { l.push(n.id) }, 0), b.autozindex) { for (var m = document.getElementsByTagName('*'), y = m.length, _ = 0, k = 0; k < y; k++) { let w = t(m[k]).css('z-index'); w !== 'auto' && _ < (w = parseInt(w, 10)) && (_ = w) } a[n.id] = _, b.background && a[n.id] > 0 && t('#' + n.id + '_background').css({ zIndex: a[n.id] + 1 }), a[n.id] > 0 && v.css({ zIndex: a[n.id] + 2 }) } b.detach ? (v.prepend(n), f.show()) : v.show(), o = setTimeout(function () { v.css({ visibility: 'visible', opacity: 1 }), t('html').addClass('popup_visible').addClass('popup_visible_' + n.id), v.addClass('popup_wrapper_visible') }, 20), b.scrolllock && (h.css('overflow', 'hidden'), h.height() > i.height() && h.css('margin-right', p + e)), b.backgroundactive && f.css({ top: (i.height() - (f.get(0).offsetHeight + parseInt(f.css('margin-top'), 10) + parseInt(f.css('margin-bottom'), 10))) / 2 + 'px' }), f.css({ visibility: 'visible', opacity: 1 }), b.background && (g.css({ visibility: 'visible', opacity: b.opacity }), setTimeout(function () { g.css({ opacity: b.opacity }) }, 0)), f.data('popup-visible', !0), c.reposition(n, r), f.data('focusedelementbeforepopup', document.activeElement), b.keepfocus && (f.attr('tabindex', -1), setTimeout(function () { b.focuselement === 'closebutton' ? t('#' + n.id + ' .' + n.id + '_close:first').focus() : b.focuselement ? t(b.focuselement).focus() : f.focus() }, b.focusdelay)), t(b.pagecontainer).attr('aria-hidden', !0), f.attr('aria-hidden', !1), u(n, r, b.onopen), d ? v.one('transitionend', function () { u(n, r, b.opentransitionend) }) : u(n, r, b.opentransitionend), b.type == 'tooltip' && t(window).on('resize.' + n.id, function () { c.reposition(n, r) }) } }, hide: function (e, i) { const n = t.inArray(e.id, l); if (n !== -1) { o && clearTimeout(o); const a = t('body'); const r = t(e); const c = r.data('popupoptions'); const f = t('#' + e.id + '_wrapper'); const h = t('#' + e.id + '_background'); r.data('popup-visible', !1), l.length === 1 ? t('html').removeClass('popup_visible').removeClass('popup_visible_' + e.id) : t('html').hasClass('popup_visible_' + e.id) && t('html').removeClass('popup_visible_' + e.id), l.splice(n, 1), f.hasClass('popup_wrapper_visible') && f.removeClass('popup_wrapper_visible'), c.keepfocus && !i && setTimeout(function () { t(r.data('focusedelementbeforepopup')).is(':visible') && r.data('focusedelementbeforepopup').focus() }, 0), f.css({ visibility: 'hidden', opacity: 0 }), r.css({ visibility: 'hidden', opacity: 0 }), c.background && h.css({ visibility: 'hidden', opacity: 0 }), t(c.pagecontainer).attr('aria-hidden', !1), r.attr('aria-hidden', !0), u(e, s[e.id], c.onclose), d && r.css('transition-duration') !== '0s' ? r.one('transitionend', function (t) { r.data('popup-visible') || (c.detach ? r.hide().detach() : f.hide()), c.scrolllock && setTimeout(function () { a.css({ overflow: 'visible', 'margin-right': p }) }, 10), u(e, s[e.id], c.closetransitionend) }) : (c.detach ? r.hide().detach() : f.hide(), c.scrolllock && setTimeout(function () { a.css({ overflow: 'visible', 'margin-right': p }) }, 10), u(e, s[e.id], c.closetransitionend)), c.type == 'tooltip' && t(window).off('resize.' + e.id) } }, toggle: function (e, o) { t(e).data('popup-visible') ? c.hide(e) : setTimeout(function () { c.show(e, o) }, 0) }, reposition: function (e, o) { const n = t(e); const a = n.data('popupoptions'); const s = t('#' + e.id + '_wrapper'); t('#' + e.id + '_background'); if (o = o || 0, a.type == 'tooltip') { s.css({ position: 'absolute' }); let p; const l = (p = a.tooltipanchor ? t(a.tooltipanchor) : a.openelement ? t(a.openelement).filter('[data-popup-ordinal="' + o + '"]') : t('.' + e.id + '_open[data-popup-ordinal="' + o + '"]')).offset(); a.horizontal == 'right' ? s.css('left', l.left + p.outerWidth() + a.offsetleft) : a.horizontal == 'leftedge' ? s.css('left', l.left + p.outerWidth() - p.outerWidth() + a.offsetleft) : a.horizontal == 'left' ? s.css('right', i.width() - l.left - a.offsetleft) : a.horizontal == 'rightedge' ? s.css('right', i.width() - l.left - p.outerWidth() - a.offsetleft) : s.css('left', l.left + p.outerWidth() / 2 - n.outerWidth() / 2 - parseFloat(n.css('marginLeft')) + a.offsetleft), a.vertical == 'bottom' ? s.css('top', l.top + p.outerHeight() + a.offsettop) : a.vertical == 'bottomedge' ? s.css('top', l.top + p.outerHeight() - n.outerHeight() + a.offsettop) : a.vertical == 'top' ? s.css('bottom', i.height() - l.top - a.offsettop) : a.vertical == 'topedge' ? s.css('bottom', i.height() - l.top - n.outerHeight() - a.offsettop) : s.css('top', l.top + p.outerHeight() / 2 - n.outerHeight() / 2 - parseFloat(n.css('marginTop')) + a.offsettop) } else a.type == 'overlay' && (a.horizontal ? s.css('text-align', a.horizontal) : s.css('text-align', 'center'), a.vertical ? n.css('vertical-align', a.vertical) : n.css('vertical-align', 'middle')) }, addclosebutton: function (e) { let o; o = t(e).data('popupoptions').closebuttonmarkup ? t(n.closebuttonmarkup).addClass(e.id + '_close') : '<button class="popup_close ' + e.id + '_close" title="Close" aria-label="Close"><span aria-hidden="true">Ã—</span></button>', t(e).data('popup-initialized') && t(e).append(o) } }; var u = function (e, o, i) { const n = t(e).data('popupoptions'); const a = n.openelement ? n.openelement : '.' + e.id + '_open'; const s = t(a + '[data-popup-ordinal="' + o + '"]'); typeof i === 'function' && i.call(t(e), e, s) }; t(document).on('keydown', function (e) { if (l.length) { const o = l[l.length - 1]; const i = document.getElementById(o); t(i).data('popupoptions').escape && e.keyCode == 27 && c.hide(i) } }), t(document).on('click', function (e) { if (l.length) { const o = l[l.length - 1]; const i = document.getElementById(o); const n = t(i).data('popupoptions').closeelement ? t(i).data('popupoptions').closeelement : '.' + i.id + '_close'; t(e.target).closest(n).length && (e.preventDefault(), c.hide(i)), t(i).data('popupoptions').blur && !t(e.target).closest('#' + o).length && e.which !== 2 && t(e.target).is(':visible') && (t(i).data('popupoptions').background ? (c.hide(i), e.preventDefault()) : c.hide(i, !0)) } }), t(document).on('keydown', function (e) { if (l.length && e.which == 9) { const o = l[l.length - 1]; const i = document.getElementById(o); const n = t(i).find('*').filter('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]').filter(':visible'); const a = t(':focus'); const s = n.length; const p = n.index(a); s === 0 ? (t(i).focus(), e.preventDefault()) : e.shiftKey ? p === 0 && (n.get(s - 1).focus(), e.preventDefault()) : p == s - 1 && (n.get(0).focus(), e.preventDefault()) } }), t.fn.popup = function (e) { return this.each(function () { const o = t(this); if (typeof e === 'object') { const i = t.extend({}, t.fn.popup.defaults, o.data('popupoptions'), e); o.data('popupoptions', i), n = o.data('popupoptions'), c._init(this) } else typeof e === 'string' ? (o.data('popupoptions') || (o.data('popupoptions', t.fn.popup.defaults), n = o.data('popupoptions')), c[e].call(this, this)) : (o.data('popupoptions') || (o.data('popupoptions', t.fn.popup.defaults), n = o.data('popupoptions')), c._init(this)) }) }, t.fn.popup.defaults = { type: 'overlay', autoopen: !1, background: !0, backgroundactive: !1, color: 'black', opacity: '0.5', horizontal: 'center', vertical: 'middle', offsettop: 0, offsetleft: 0, escape: !0, blur: !0, setzindex: !0, autozindex: !1, scrolllock: !1, closebutton: !1, closebuttonmarkup: null, keepfocus: !0, focuselement: null, focusdelay: 50, outline: !1, pagecontainer: null, detach: !1, openelement: null, closeelement: null, transition: null, tooltipanchor: null, beforeopen: null, onclose: null, onopen: null, opentransitionend: null, closetransitionend: null } }(jQuery))
